<template>
  <div>
    <Fieldset :legend="$t('searchHeader')" :toggleable="true">
      <div class="p-fluid p-mt-2 p-ml-3 p-mr-3 p-mb-2" @keyup.enter="saveData_Modal('search')">
        <div class="p-formgrid p-grid p-col">
          <div class="p-field p-col-12 p-lg-4 p-mt-2">
            <label for="victim_name">{{ $t("iv_victim_name") }}</label>
            <InputText 
              id="victim_name" 
              type="text" 
              v-model="victim_name" 
              ref="TextBox_1_search"
              @keyup.left="moveFocus($event, 'TextBox_6_search','Button')"
              @keyup.right="moveFocus($event, 'TextBox_2_search','Input')"
              @keyup.down="moveFocus($event, 'TextBox_3_search','Button')"
            />
          </div>
          <div class="p-field p-col-12 p-lg-3 p-mt-2">
            <label for="idnumber">{{ $t("iv_victim_idnumber") }}</label>
            <InputText
              id="idnumber"
              type="text"
              v-model="idnumber"
              @input="acceptIDNumberSearch()"
              ref="TextBox_2_search"
              @keyup.left="moveFocus($event, 'TextBox_1_search','Input')"
              @keyup.right="moveFocus($event, 'TextBox_3_search','Button')"
              @keyup.down="moveFocus($event, 'TextBox_4_search','Button')"
            />
          </div>
          <div class="p-field p-col-12 p-lg-3 p-mt-2">
            <label for="victimStatusSelected">{{
              $t("iv_victim_status")
            }}</label>
            <Dropdown
              v-model="victimStatusSelected"
              :options="victimStatusOptions"
              optionLabel="system_name"
              :filter="true"
              :placeholder="$t('placeholderSelectBox')"
              :showClear="true"
              :clearFilterDropdown="dropdownClearFilerValue"
            >
              <template #value="victimStatusOptions">
                <div v-if="victimStatusOptions.value">
                  <div>{{ victimStatusOptions.value.system_name }}</div>
                </div>
                <span v-else>
                  {{ victimStatusOptions.placeholder }}
                </span>
              </template>
              <template #option="victimStatusOptions">
                <div>{{ victimStatusOptions.option.system_name }}</div>
              </template>
            </Dropdown>
          </div>
          <div class="p-field p-col-12 p-lg-2 p-mt-3">
            <div class="p-field-checkbox p-mt-5">
              <Checkbox
                id="iv_table_headerFamily"
                name="iv_table_headerFamily"
                value="1"
                v-model="iv_checked_headerFamily"
              />
              <label for="iv_table_headerFamily">{{
                $t("iv_table_headerFamily")
              }}</label>
            </div>
          </div>
        </div>
        <div class="p-formgrid p-grid p-col">
          <div class="p-field p-col-8 p-lg-4 p-mt-2">
            <label for="victim_disaster">{{ $t("iv_victim_disaster") }}</label>
            <InputText
              id="victim_disaster"
              type="text"
              v-model="selectedEvent.name"
              disabled
            />
          </div>
          <div class="p-field p-mr-3" style="padding: 3.5px 0 0 0;">
            <Button
              @click="showDisasterEvent = true"
              icon="pi pi-ellipsis-h"
              class="p-button-secondary p-mt-5 p-mr-2"
              ref="TextBox_3_search"
              @keyup.left="moveFocus($event, 'TextBox_2_search','Input')"
              @keyup.right="moveFocus($event, 'TextBox_4_search','Button')"
              @keyup.up="moveFocus($event, 'TextBox_1_search','Input')"
            />
            <Button
              @click="selectedEvent = {}"
              icon="pi pi-times"
              class="p-button-danger p-mt-5"
              ref="TextBox_4_search"
              @keyup.left="moveFocus($event, 'TextBox_3_search','Button')"
              @keyup.right="moveFocus($event, 'TextBox_5_search','Button')"
              @keyup.up="moveFocus($event, 'TextBox_1_search','Input')"
            />
          </div>
          <div class="p-field p-col-12 p-lg-3 p-mt-2">
            <label for="disaster_date">{{
              $t("iv_victim_disaster_date")
            }}</label>
            <Calendar
              dateFormat="dd/mm/yy"
              :showButtonBar="true"
              :monthNavigator="true"
              :yearNavigator="true"
              yearRange="2000:2050"
              :locale="th"
              id="disaster_date"
              v-model="disaster_date"
            ></Calendar>
          </div>
          <div class="p-field p-col">
            <div class="p-formgrid p-grid p-jc-end p-mt-5">
              <Button
                @click="clearSearchField()"
                :label="$t('clearBtn')"
                class="p-button-clear p-ml-3 p-mr-3"
                ref="TextBox_5_search"
                @keyup.left="moveFocus($event, 'TextBox_4_search','Button')"
                @keyup.right="moveFocus($event, 'TextBox_6_search','Button')"
                @keyup.up="moveFocus($event, 'TextBox_2_search','Input')"
              />
              <Button
                @click="searchVictimInfo()"
                :label="$t('searchBtn')"
                class="p-button-info"
                ref="TextBox_6_search"
                @keyup.left="moveFocus($event, 'TextBox_5_search','Button')"
                @keyup.right="moveFocus($event, 'TextBox_1_search','Input')"
                @keyup.up="moveFocus($event, 'TextBox_2_search','Input')"
              />
            </div>
          </div>
        </div>
          <div class="p-formgrid p-grid p-col p-mt-1">
                <text-footer
                  :data="Data_text_Footer"
                  :checkShow="text_Footer"
                  :countItem="victimInfo_table.length.toLocaleString('en-US')"
                />
          </div>
      </div>
    </Fieldset>

    <Dialog
      :modal="true"
      :header="$t('disasterEventModalHeader')"
      :visible.sync="showDisasterEvent"
      :contentStyle="{ 'overflow-y': 'scroll' }"
      :style="{ width: '90%' }"
    >
      <disaster-event @selectEvent="selectedEvent_passValue"></disaster-event>
    </Dialog>

    <Dialog
      :modal="true"
      :header="$t('OrganizeModalHeader')"
      :visible.sync="showOrganize"
      :contentStyle="{ 'overflow-y': 'scroll' }"
      :style="{ width: '80%' }"
    >
      <organize-table
        @selectOrganization="selectedOrganize_passValue"
      ></organize-table>
    </Dialog>

    <div class="card p-fluid p-mt-2">
      <DataTable
        :value="victimInfo_table"
        :paginator="true"
        :rows="10"
        scrollHeight="500px"
        dataKey="id"
        :rowHover="true"
        :filters="filters"
        sortField="index"
        :sortOrder="1"
        :loading="loading"
        paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
        :rowsPerPageOptions="[10, 20, 50]"
        currentPageReportTemplate="แสดงผล {first} ถึง {last} จากทั้งหมด {totalRecords}"
      >
        <template #header>
          <div class="p-grid">
            <div class="table-header p-col-12 p-lg-1" style="padding: 7px;  " id="Create" v-if="checkAdd_data != 'false'">
              <Button
                @click="victimInfoModal = true"
                :label="$t('addBtn')"
                class="p-button-success"
              />
            </div>
            <div class="table-header p-col-6 p-lg-3" id="Search" style="margin-left: auto">
              <span class="p-input-icon-left">
                <i class="pi pi-search" /><InputText
                  v-model="filters['global']"
                  :placeholder="$t('searchHeader')"
                />
              </span>
            </div>
          </div>
        </template>
        <template #empty>{{ $t("TableEmpty") }}</template>

        <Column
          field="index"
          :header="'ลำดับ'"
          :sortable="true"
          :headerStyle="tableColSticky('100px','center','sticky','top')"
        >
          <template #body="dataTable">
            <div class="table_row">
              {{ dataTable.data.index }}
            </div> 
          </template>
        </Column>

        <Column
          field="event_name"
          :header="$t('event_name')"
          :sortable="true"
          :headerStyle="tableColSticky('250px','','sticky','top')"
        >
          <template #body="dataTable">
 
            <div hidden>{{ dataTable.data.victim_id }}</div>
            {{ dataTable.data.event_name }}
          </template>
        </Column>
        <Column
          field="event_date"
          :header="$t('disaster_callDatetime')"
          :sortable="true"
          :headerStyle="tableColSticky('15rem','','sticky','top')"
        >
          <template #body="dataTable">
            {{ dataTable.data.event_date }}
          </template>
        </Column>
        <Column
          field="header"
          :header="$t('iv_table_headerFamily')"
          :sortable="true"
          :headerStyle="tableColSticky('250px','','sticky','top')"
        >
          <template #body="dataTable">
            <div v-if="dataTable.data.header == '1'">
              <div v-if="dataTable.data.prefix != 'null'">
                {{ dataTable.data.prefix_name }} {{ dataTable.data.firstname }}
                {{ dataTable.data.lastname }}
              </div>
              <div v-else>
                {{ dataTable.data.firstname }} {{ dataTable.data.lastname }}
              </div>
            </div>
            <div v-else>-</div>
            <div v-if="dataTable.data.victim_id == '1'">
              <div v-if="dataTable.data.prefix != 'null'">
                {{ dataTable.data.prefix_name }} {{ dataTable.data.firstname }}
                {{ dataTable.data.lastname }}
              </div>
              <div v-else>
                {{ dataTable.data.firstname }} {{ dataTable.data.lastname }}
              </div>
            </div>
          </template>
        </Column>
        <Column
          field="firstname"
          :header="$t('iv_victim_name')"
          :sortable="true"
          :headerStyle="tableColSticky('250px','','sticky','top')"
        >
          <template #body="dataTable">
            <div v-if="dataTable.data.prefix != 'null'">
              {{ dataTable.data.prefix_name }} {{ dataTable.data.firstname }}
              {{ dataTable.data.lastname }}
            </div>
            <div v-else>
              {{ dataTable.data.firstname }} {{ dataTable.data.lastname }}
            </div>
          </template>
        </Column>
        <Column
          field="location"
          :header="$t('iv_table_address')"
          :sortable="true"
          :headerStyle="tableColSticky('300px','','sticky','top')"
        >
          <template #body="dataTable">
            <div v-if="dataTable.data.location == ''">-</div>
            <div v-else>{{ dataTable.data.location }}</div>
          </template>
        </Column>
        <Column
          field="idnumber"
          :header="$t('iv_victim_idnumber')"
          :sortable="true"
          :headerStyle="tableColSticky('230px','','sticky','top')"
        >
          <template #body="dataTable">
            <div v-if="dataTable.data.idnumber == ''">-</div>
            <div v-else>{{ dataTable.data.idnumber }}</div>
          </template>
        </Column>
        <Column
          field="status_name"
          :header="$t('iv_victim_status')"
          :sortable="true"
          :headerStyle="tableColSticky('150px','center','sticky','top')"
        >
          <template #body="dataTable">
            <div class="table_row">
              {{ dataTable.data.status_name }}
            </div>
            
          </template>
        </Column>

          <Column
            field="date_create_ddmmyy"
            :header="'วันที่สร้างข้อมูล'"
            :sortable="true"
            :headerStyle="tableColSticky('15rem','','sticky','top')"
          >
            <template #body="dataTable">
                {{ dataTable.data.date_create_ddmmyy }}
            </template>
          </Column>

          <Column
            field="date_update_ddmmyy"
            :header="'วันที่ปรับปรุงข้อมูล'"
            :sortable="true"
            :headerStyle="tableColSticky('15rem','','sticky','top')"
          >
            <template #body="dataTable">
                {{ dataTable.data.date_update_ddmmyy }}
            </template>
          </Column>

        <Column :header="$t('controlTable')" 
        :headerStyle="table_headerStyle"    
        :bodyStyle="table_bodyStyle"
        v-if="checkEdit_data != 'false' || checkDelete_data != 'false' ">
          <template #body="dataTable">
            <div class="p-formgrid col_manege" v-if="checkNotAdminPermission(dataTable.data.user_organize)">
            <!-- <div class="p-formgrid p-grid"> -->
              <div :class="table_BOXmanege" v-if="checkEdit_data != 'false'">
                <Button
                  @click="
                    victimInfoModal = true;
                    editData(dataTable.data.victim_id);
                  "
                  icon="pi pi-pencil"
                  :label="table_editBTN"
                  class="p-button-rounded p-button-warning"
                />
              </div>
              <div :class="table_BOXmanege" v-if="checkDelete_data != 'false'">
                <Button
                  @click="
                    // displayConfirmation = true;
                    temp = dataTable.data.member_id;
                    alertDisplay(temp)
                  "
                  icon="pi pi-trash"
                  :label="table_deleteBTN"
                  class="p-button-rounded p-button-danger"
                />
              </div>
            </div>
            <div v-else >
              {{"ไม่มีสิทธิ์จัดการข้อมูลนี้"}}
            </div>
          </template>
        </Column>
      </DataTable>
    </div>

    <!-- Manage data -->
    <Dialog
      :modal="true"
      :visible.sync="victimInfoModal"
      :style="{ width: '90%' }"
      :contentStyle="{ 'overflow-y': 'scroll' }"
      :header="header"
    >
      <div class="confirmation-content" @keyup.enter="saveData_Modal('Modal_Main')">
        <label>{{ $t("iv_modal_subtitle") }}</label>
        <div class="p-fluid p-mt-3">
          <div class="p-formgrid p-grid p-col">
            <div class="p-field p-col-8 p-lg-4 p-mt-2">
              <label for="iv_disaster_name">{{ $t("event_name") }} </label
              ><span class="required-input p-ml-2">*</span>
              <InputText
                id="iv_disaster_name"
                type="text"
                v-model="iv_disaster_name.name"
                disabled
                :class="{
                  'p-invalid': error_iv_disaster_name && !iv_disaster_name.name,
                }"
              />
              <small
                class="p-invalid"
                v-if="error_iv_disaster_name && !iv_disaster_name.name"
                >{{ $t("iv_disaster_name_validate") }}</small
              >
            </div>
            <div class="p-field p-mr-3 " style="padding: 4.5px 0 0 0;">
              <Button
                @click="showDisasterEvent = true"
                icon="pi pi-ellipsis-h"
                class="p-button-secondary p-mt-5 p-mr-2"
                autofocus
                ref="TextBox_1"
                @keyup.left="moveFocus($event, 'TextBox_9','Button')"
                @keyup.right="moveFocus($event, 'TextBox_2','Button')"
                @keyup.down="moveFocus($event, 'TextBox_3','InputNumber')"
              />
              <Button
                @click="
                  iv_disaster_name = {};
                  iv_operating_modal_receive = '';
                "
                icon="pi pi-times"
                class="p-button-danger p-mt-5"
                ref="TextBox_2"
                @keyup.left="moveFocus($event, 'TextBox_1','Button')"
                @keyup.right="moveFocus($event, 'TextBox_3','InputNumber')"
                @keyup.down="moveFocus($event, 'TextBox_4','InputNumber')"
              />
            </div>

            <div class="p-field p-col-12 p-lg-4 p-mt-2">
              <label for="iv_operating_modal_receive">{{
                $t("id_operating_modal_receive")
              }}</label>
              <InputText
                id="iv_operating_modal_receive"
                type="text"
                v-model="iv_operating_modal_receive"
                disabled
              />
            </div>
          </div>

          <div class="p-formgrid p-grid p-col" style="display:flex;justify-content:flex-end;">
            <div class="p-field p-col-12 p-lg-2">
              <label for="date_create_form">วันที่สร้างข้อมูล <span class="required-input"> </span></label>
                <InputText
                    id="date_create_form"
                    type="text"
                    v-model="date_create_form"
                    autofocus
                    disabled
                />
            </div>
            <div class="p-field p-col-12 p-lg-2">
              <label for="date_update_form">{{
                      $t("imp_update_info_date")
                    }}<span class="required-input"> </span></label>
                <InputText
                    id="date_update_form"
                    type="text"
                    v-model="date_update_form"
                    autofocus
                    disabled
                />
            </div>
          </div>
          
          <hr />
          <h5>{{ $t("iv_modal_help_topic") }}</h5>
          <div class="p-formgrid p-grid p-col">
            <div class="p-field p-col-12 p-lg-3 p-mt-2">
              <label for="iv_modal_help_consumer">{{
                $t("iv_modal_help_consumer")
              }}</label>
              <InputNumber
                id="iv_modal_help_consumer"
                mode="decimal"
                :min="0"
                :minFractionDigits="2"
                :maxFractionDigits="2"
                v-model="iv_modal_help_consumer"
                ref="TextBox_3"
                @keyup.left="moveFocus($event, 'TextBox_2','Button')"
                @keyup.right="moveFocus($event, 'TextBox_4','InputNumber')"
                @keyup.up="moveFocus($event, 'TextBox_1','Button')"
                @keyup.down="moveFocus($event, 'TextBox_7','Button')"
              />
            </div>
            <div class="p-field p-col-12 p-lg-3 p-mt-2">
              <label for="iv_modal_help_temporary">{{
                $t("iv_modal_help_temporary")
              }}</label>
              <InputNumber
                id="iv_modal_help_temporary"
                mode="decimal"
                :min="0"
                :minFractionDigits="2"
                :maxFractionDigits="2"
                v-model="iv_modal_help_temporary"
                ref="TextBox_4"
                @keyup.left="moveFocus($event, 'TextBox_3','InputNumber')"
                @keyup.right="moveFocus($event, 'TextBox_5','InputNumber')"
                @keyup.up="moveFocus($event, 'TextBox_1','Button')"
                @keyup.down="moveFocus($event, 'TextBox_7','Button')"
              />
            </div>
            <div class="p-field p-col-12 p-lg-3 p-mt-2">
              <label for="iv_modal_help_occupation">{{
                $t("iv_modal_help_occupation")
              }}</label>
              <InputNumber
                id="iv_modal_help_occupation"
                mode="decimal"
                :min="0"
                :minFractionDigits="2"
                :maxFractionDigits="2"
                v-model="iv_modal_help_occupation"
                ref="TextBox_5"
                @keyup.left="moveFocus($event, 'TextBox_4','InputNumber')"
                @keyup.right="moveFocus($event, 'TextBox_6','InputNumber')"
                @keyup.up="moveFocus($event, 'TextBox_1','Button')"
                @keyup.down="moveFocus($event, 'TextBox_7','Button')"
              />
            </div>
            <div class="p-field p-col-12 p-lg-3 p-mt-2">
              <label for="iv_modal_help_contribution">{{
                $t("iv_modal_help_contribution")
              }}</label>
              <InputNumber
                id="iv_modal_help_contribution"
                mode="decimal"
                :min="0"
                :minFractionDigits="2"
                :maxFractionDigits="2"
                v-model="iv_modal_help_contribution"
                ref="TextBox_6"
                @keyup.left="moveFocus($event, 'TextBox_5','InputNumber')"
                @keyup.right="moveFocus($event, 'TextBox_7','Button')"
                @keyup.up="moveFocus($event, 'TextBox_1','Button')"
                @keyup.down="moveFocus($event, 'TextBox_7','Button')"
              />
            </div>
          </div>

          <hr />
          <div class="p-formgrid p-grid p-col-12">
            <div class="p-field p-col-10">
              <label>
                {{ $t("iv_modal_member_topic") }}
                <span class="required-input">*</span>
              </label>
            </div>
            <div class="p-field p-col-6 p-lg-2 p-justify-end">
              <Button
                @click="memberSubModal = true"
                icon="pi pi-plus"
                :label="$t('addBtn')"
                class="p-button-success"
                ref="TextBox_7"
                @keyup.left="moveFocus($event, 'TextBox_6','InputNumber')"
                @keyup.right="moveFocus($event, 'TextBox_8','Button')"
                @keyup.up="moveFocus($event, 'TextBox_6','InputNumber')"
                @keyup.down="moveFocus($event, 'TextBox_8','Button')"
              />

              

            </div>
          </div>
          <span class="p-invalid p-ml-3" v-if="error_member_table == true"
            >{{ $t("member_table_validate") }}
          </span>
          <div class="p-formgrid p-grid p-col-12">
            <!-- :scrollable="true" -->
            <div class="p-field p-col-12">
              <DataTable
                :value="member_table"
                
                scrollHeight="500px"
                :paginator="true"
                :rows="5"
                dataKey="id"
                :rowHover="true"
                
                paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                :rowsPerPageOptions="[5, 10, 20, 50]"
                currentPageReportTemplate="แสดงผล {first} ถึง {last} จากทั้งหมด {totalRecords}"
              >
                <template #empty>{{ $t("TableEmpty") }}</template>
                <Column
                  field="id"
                  :header="$t('iv_member_table_no')"
                  :sortable="true"
                  :headerStyle="tableColSticky('8rem','center','sticky','top')"
                >
                  <template #body="dataTable">
                    <div hidden>{{ dataTable.data.member_id }}</div>
                    {{ member_table.indexOf(dataTable.data) + 1 }}
                  </template>
                </Column>
                <Column
                  field="idnumber"
                  :header="$t('iv_victim_idnumber')"
                  :sortable="true"
                  :headerStyle="tableColSticky('15rem','','sticky','top')"
                >
                  <template #body="dataTable">
                    <div v-if="dataTable.data.idnumber == ''">-</div>
                    <div v-else>{{ dataTable.data.idnumber }}</div>
                  </template>
                </Column>
                <Column
                  field="firstname"
                  :header="$t('iv_member_table_name')"
                  :sortable="true"
                  :headerStyle="tableColSticky('15rem','','sticky','top')"
                >
                  <template #body="dataTable">
                    {{ dataTable.data.firstname }} {{ dataTable.data.lastname }}
                  </template>
                </Column>
                <Column
                  field="relation"
                  :header="$t('iv_member_table_relationship')"
                  :sortable="true"
                  :headerStyle="tableColSticky('15rem','','sticky','top')"
                >
                  <template #body="dataTable">
                    <div v-if="dataTable.data.relation == ''">-</div>
                    <div v-else>{{ dataTable.data.relation }}</div>
                  </template>
                </Column>
                <Column
                  field="gender"
                  :header="$t('iv_member_table_gender')"
                  :sortable="true"
                  :headerStyle="tableColSticky('15rem','','sticky','top')"
                >
                  <template #body="dataTable">
                    <div v-if="dataTable.data.gender == '1'">
                      {{ $t("iv_male") }}
                    </div>
                    <div v-else-if="dataTable.data.gender == '2'">
                      {{ $t("iv_female") }}
                    </div>
                    <div v-else>-</div>
                  </template>
                </Column>
                <Column
                  field="age"
                  :header="$t('iv_member_table_age')"
                  :sortable="true"
                  :headerStyle="tableColSticky('15rem','','sticky','top')"
                >
                  <template #body="dataTable">
                    <div v-if="dataTable.data.age != '0'">
                      {{ dataTable.data.age }}
                    </div>
                    <div v-else>-</div>
                  </template>
                </Column>
                <Column
                  field="nationality"
                  :header="$t('iv_member_table_nationality')"
                  :sortable="true"
                  :headerStyle="tableColSticky('15rem','','sticky','top')"
                >
                  <template #body="dataTable">
                    <div v-if="dataTable.data.nationality == ''">-</div>
                    <div v-else>{{ dataTable.data.nationality }}</div>
                  </template>
                </Column>
                <Column
                  field="occupation"
                  :header="$t('iv_member_table_occupation')"
                  :sortable="true"
                  :headerStyle="tableColSticky('15rem','','sticky','top')"
                >
                  <template #body="dataTable">
                    <div v-if="dataTable.data.occupation == ''">-</div>
                    <div v-else>{{ dataTable.data.occupation }}</div>
                  </template>
                </Column>
                <Column
                  field="status_name"
                  :header="$t('iv_victim_status')"
                  :sortable="true"
                  :headerStyle="tableColSticky('15rem','','sticky','top')"
                >
                  <template #body="dataTable">
                    {{ dataTable.data.status_name }}
                  </template>
                </Column>

                <Column
                  field="date_create_ddmmyy"
                  :header="'วันที่สร้างข้อมูล'"
                  :sortable="true"
                  :headerStyle="tableColSticky('15rem','','sticky','top')"
                >
                  <template #body="dataTable">
                    <div v-if="dataTable.data.date_create_ddmmyy == null ||
                               dataTable.data.date_create_ddmmyy == 'null' ||
                               dataTable.data.date_create_ddmmyy == '' ">
                      
                      -
                    </div>
                    <div v-else>
                      {{ changeDateToThai(checkDate(dataTable.data.date_create_ddmmyy)) }}
                    </div>
                  </template>
                </Column>

                <Column
                  field="date_update_ddmmyy"
                  :header="'วันที่ปรับปรุงข้อมูล'"
                  :sortable="true"
                  :headerStyle="tableColSticky('15rem','','sticky','top')"
                >
                  <template #body="dataTable">
                    <div v-if="dataTable.data.date_update_ddmmyy == null ||
                               dataTable.data.date_update_ddmmyy == 'null' ||
                               dataTable.data.date_update_ddmmyy == '' ">
                      
                      -
                    </div>
                    <div v-else>
                      {{ changeDateToThai(checkDate(dataTable.data.date_update_ddmmyy)) }}
                    </div>
                  </template>
                </Column>

                <!-- ส่วน สมาชิกในครอบครัว * -->
                <Column :header="$t('controlTable')" 
                :headerStyle="table_headerStyle"    
                :bodyStyle="table_bodyStyle"
                >
                  <template #body="dataTable">
                    <div class="p-formgrid p-grid" style="text-align: center">
                      <div :class="table_BOXmanege">
                        <Button
                          @click="
                            memberSubModal = true;
                            editMemberData(dataTable.data.member_id);
                          "
                          icon="pi pi-pencil"
                          class="p-button-rounded p-button-warning"
                        />
                      </div>
                      <div :class="table_BOXmanege">
                        <Button
                          @click="
                            // displayConfirmation = true;
                            memberTableDelete = dataTable.data;
                            deleteAt = 'member-table';
                            alertDisplay(memberTableDelete,deleteAt)
                          "
                          icon="pi pi-trash"
                          class="p-button-rounded p-button-danger"
                        />
                      </div>
                    </div>
                  </template>
                </Column>
              </DataTable>
            </div>
          </div>
        </div>
      </div>
      <template #footer>
        <Button
          v-if="selectedData != ''"
          :label="$t('cancelBtn')"
          icon="pi pi-times"
          class="p-button-text"
          @click="clearData()"
          ref="TextBox_8"
          @keyup.left="moveFocus($event, 'TextBox_7','Button')"
          @keyup.right="moveFocus($event, 'TextBox_9','Button')"
          @keyup.up="moveFocus($event, 'TextBox_7','Button')"
        />
        <Button
          v-else
          :label="$t('clearBtn')"
          icon="pi pi-times"
          class="p-button-text"
          @click="clearData()"
          ref="TextBox_8"
          @keyup.left="moveFocus($event, 'TextBox_7','Button')"
          @keyup.right="moveFocus($event, 'TextBox_9','Button')"
          @keyup.up="moveFocus($event, 'TextBox_7','Button')"
        />
        <Button
          :label="$t('saveBtn')"
          icon="pi pi-check"
          class="p-button-text"
          @click="saveData()"
          ref="TextBox_9"
          @keyup.left="moveFocus($event, 'TextBox_8','Button')"
          @keyup.right="moveFocus($event, 'TextBox_1','Button')"
          @keyup.up="moveFocus($event, 'TextBox_7','Button')"
        />
      </template>
    </Dialog>

    <!-- Manage member family data -->
    <Dialog
      :modal="true"
      :visible.sync="memberSubModal"
      :style="{ width: '90%' }"
      :contentStyle="{ 'overflow-y': 'scroll' }"
      :header="headerSubModal"
    >
      <div class="confirmation-content" @keyup.enter="saveData_Modal('Member_Model')">
        <label>{{ $t("iv_modal_subtitle") }}</label>
        <div class="p-fluid p-mt-5">
          <div class="p-formgrid p-grid p-col">
            <div hidden>{{ ivs_member }}</div>
            <div class="p-field p-col-12 p-lg-3 p-mt-2">
              <label for="ivs_prefix_name">{{ $t("imp_prefix_name") }}
                <span class="required-input"></span></label>
              <Dropdown
                v-model="ivs_prefix_name"
                :options="prefixOptions"
                optionLabel="system_name"
                :filter="true"
                :placeholder="$t('placeholderSelectBox')"
                :showClear="true"
                :clearFilterDropdown="dropdownClearFilerValue"
              >
                <template #value="prefixOptions">
                  <div v-if="prefixOptions.value">
                    <div>{{ prefixOptions.value.system_name }}</div>
                  </div>
                  <span v-else>
                    {{ prefixOptions.placeholder }}
                  </span>
                </template>
                <template #option="prefixOptions">
                  <div>{{ prefixOptions.option.system_name }}</div>
                </template>
              </Dropdown>
            </div>
            <div class="p-field p-col-12 p-lg-3 p-mt-2" >
              <label for="ivs_firstname"
                >{{ $t("imp_firstname") }}
                <span class="required-input">*</span></label
              >
              <InputText
                id="ivs_firstname"
                type="text"
                v-model="ivs_firstname"
                :class="{ 'p-invalid': error_ivs_firstname && !ivs_firstname }"
                ref="TextBox_1_Member"
                @keyup.left="moveFocus($event, 'TextBox_22_Member','Button')"
                @keyup.right="moveFocus($event, 'TextBox_2_Member','Input')"
                @keyup.down="moveFocus($event, 'TextBox_4_Member','Input')"
              />
              <small
                class="p-invalid"
                v-if="error_ivs_firstname && !ivs_firstname"
                >{{ $t("ivs_firstname_validate") }}</small
              >
            </div>
            <div class="p-field p-col-12 p-lg-3 p-mt-2">
              <label for="ivs_lastname">{{ $t("imp_lastname") }}
                <span class="required-input"></span></label>
              <InputText 
                id="ivs_lastname" 
                type="text" 
                v-model="ivs_lastname" 
                ref="TextBox_2_Member"
                @keyup.left="moveFocus($event, 'TextBox_1_Member','Input')"
                @keyup.right="moveFocus($event, 'TextBox_3_Member','Input')"
                @keyup.down="moveFocus($event, 'TextBox_5_Member','Input')"
              />
            </div>
            <div class="p-field p-col-12 p-lg-3 p-mt-2">
              <label>{{ $t("iv_member_table_gender") }}</label>
              <div class="p-formgrid p-mt-2">
                <RadioButton name="gender" value="1" v-model="ivs_gender" />
                <label class="p-ml-2">{{ $t("iv_male") }}</label>
                <RadioButton
                  name="gender"
                  value="2"
                  v-model="ivs_gender"
                  class="p-ml-5"
                />
                <label class="p-ml-2">{{ $t("iv_female") }}</label>
              </div>
            </div>
          </div>

          <div class="p-formgrid p-grid p-col">
            <div class="p-field p-col-12 p-lg-3 p-mt-2">
              <label for="ivs_idnumber">{{ $t("iv_victim_idnumber") }}</label>
              <InputText
                id="ivs_idnumber"
                type="text"
                v-model="ivs_idnumber"
                @input="acceptIDNumber"
                :class="{ 'p-invalid': error_idnumber_format && !ivs_idnumber }"
                ref="TextBox_3_Member"
                @keyup.left="moveFocus($event, 'TextBox_2_Member','Input')"
                @keyup.right="moveFocus($event, 'TextBox_4_Member','Input')"
                @keyup.up="moveFocus($event, 'TextBox_1_Member','Input')"
                @keyup.down="moveFocus($event, 'TextBox_7_Member','InputNumber')"
              />
              <small
                class="p-invalid"
                v-if="error_idnumber_format && !ivs_idnumber"
                >{{ $t("ivs_idnumber_validate") }}</small
              >
            </div>
            <div class="p-field p-col-12 p-lg-3 p-mt-2">
              <label for="ivs_race">{{ $t("iv_submodal_race") }}</label>
              <InputText 
                id="ivs_race" 
                type="text" 
                v-model="ivs_race" 
                ref="TextBox_4_Member"
                @keyup.left="moveFocus($event, 'TextBox_3_Member','Input')"
                @keyup.right="moveFocus($event, 'TextBox_5_Member','Input')"
                @keyup.up="moveFocus($event, 'TextBox_1_Member','Input')"
                @keyup.down="moveFocus($event, 'TextBox_8_Member','Input')"
              />
            </div>
            <div class="p-field p-col-12 p-lg-3 p-mt-2">
              <label for="ivs_nationality">{{
                $t("iv_member_table_nationality")
              }}</label>
              <InputText
                id="ivs_nationality"
                type="text"
                v-model="ivs_nationality"
                ref="TextBox_5_Member"
                @keyup.left="moveFocus($event, 'TextBox_4_Member','Input')"
                @keyup.right="moveFocus($event, 'TextBox_6_Member','Input')"
                @keyup.up="moveFocus($event, 'TextBox_2_Member','Input')"
                @keyup.down="moveFocus($event, 'TextBox_9_Member','Input')"
              />
            </div>
            <div class="p-field p-col-12 p-lg-3 p-mt-2">
              <label for="ivs_religion">{{ $t("iv_submodal_religion") }}</label>
              <InputText 
                id="ivs_religion" 
                type="text" 
                v-model="ivs_religion" 
                ref="TextBox_6_Member"
                @keyup.left="moveFocus($event, 'TextBox_5_Member','Input')"
                @keyup.right="moveFocus($event, 'TextBox_7_Member','InputNumber')"
                @keyup.up="moveFocus($event, 'TextBox_2_Member','Input')"
                @keyup.down="moveFocus($event, 'TextBox_9_Member','Input')"
              />
            </div>
          </div>

          <div class="p-formgrid p-grid p-col">
            <div class="p-field p-col-12 p-lg-1 p-mt-2">
              <label for="ivs_age">{{ $t("iv_member_table_age") }}</label>
              <InputNumber 
                id="ivs_age" 
                :min="0"
                v-model="ivs_age" 
                ref="TextBox_7_Member"
                @keyup.left="moveFocus($event, 'TextBox_6_Member','Input')"
                @keyup.right="moveFocus($event, 'TextBox_8_Member','Input')"
                @keyup.up="moveFocus($event, 'TextBox_3_Member','Input')"
                @keyup.down="moveFocus($event, 'TextBox_10_Member','Input')"
              />
            </div>
            <div class="p-field p-col-12 p-lg-1 p-mt-2">
              <label for="ivs_bloodgroup">{{
                $t("iv_submodal_bloodgroup")
              }}</label>
              <Dropdown
                v-model="ivs_bloodgroup"
                :options="bloodGroupOptions"
                :placeholder="$t('placeholderSelectBox')"
                optionLabel="name"
                :clearFilterDropdown="dropdownClearFilerValue"
              >
                <template #value="bloodGroupOptions">
                  <div v-if="bloodGroupOptions.value">
                    <div>{{ bloodGroupOptions.value.name }}</div>
                  </div>
                  <span v-else>
                    {{ bloodGroupOptions.placeholder }}
                  </span>
                </template>
                <template #option="bloodGroupOptions">
                  <div>{{ bloodGroupOptions.option.name }}</div>
                </template>
              </Dropdown>
            </div>
            <div class="p-field p-col-12 p-lg-4 p-mt-2">
              <label for="ivs_relationship">{{
                $t("iv_member_table_relationship")
              }}</label>
              <InputText
                id="ivs_relationship"
                type="text"
                v-model="ivs_relationship"
                ref="TextBox_8_Member"
                @keyup.left="moveFocus($event, 'TextBox_7_Member','InputNumber')"
                @keyup.right="moveFocus($event, 'TextBox_9_Member','Input')"
                @keyup.up="moveFocus($event, 'TextBox_4_Member','Input')"
                @keyup.down="moveFocus($event, 'TextBox_10_Member','Input')"
              />
            </div>
            <div class="p-field p-col-12 p-lg-6 p-mt-2">
              <label for="ivs_occupation">{{
                $t("iv_member_table_occupation")
              }}</label>
              <InputText
                id="ivs_occupation"
                type="text"
                v-model="ivs_occupation"
                ref="TextBox_9_Member"
                @keyup.left="moveFocus($event, 'TextBox_8_Member','Input')"
                @keyup.right="moveFocus($event, 'TextBox_10_Member','Input')"
                @keyup.up="moveFocus($event, 'TextBox_5_Member','Input')"
                @keyup.down="moveFocus($event, 'TextBox_10_Member','Input')"
              />
            </div>
          </div>

          <div class="p-formgrid p-grid p-col">
            <div class="p-field p-col-12 p-lg-8 p-mt-2">
              <label for="ivs_address">{{ $t("iv_table_address") }}</label>
              <InputText 
                id="ivs_address" 
                type="text" 
                v-model="ivs_address" 
                ref="TextBox_10_Member"
                @keyup.left="moveFocus($event, 'TextBox_9_Member','Input')"
                @keyup.right="moveFocus($event, 'TextBox_11_Member','Input')"
                @keyup.up="moveFocus($event, 'TextBox_7_Member','InputNumber')"
                @keyup.down="moveFocus($event, 'TextBox_11_Member','Input')"
              />
            </div>
            <div class="p-field p-col-12 p-lg-2">
              <label for="date_create_form_member">วันที่สร้างข้อมูล <span class="required-input"> </span></label>
                <InputText
                    id="date_create_form_member"
                    type="text"
                    v-model="date_create_form_member"
                    autofocus
                    disabled
                />
            </div>
            <div class="p-field p-col-12 p-lg-2">
              <label for="date_update_form_member">{{
                      $t("imp_update_info_date")
                    }}<span class="required-input"> </span></label>
                <InputText
                    id="date_update_form_member"
                    type="text"
                    v-model="date_update_form_member"
                    autofocus
                    disabled
                />
            </div>
          </div>

          <div class="p-formgrid p-grid p-col">
            <div class="p-field p-col-12 p-lg-4 p-mt-2">
              <label for="provinceOptions">{{ $t("province") }}</label>
              <Dropdown
                v-model="ivs_selectedProvince"
                :options="provinceOptions"
                optionLabel="province_name"
                @change="someHandler('ch-province')"
                :filter="true"
                :placeholder="$t('placeholderSelectBox')"
                :showClear="true"
                :clearFilterDropdown="dropdownClearFilerValue"
              >
                <template #value="provinceOptions">
                  <div v-if="provinceOptions.value">
                    <div>{{ provinceOptions.value.province_name }}</div>
                  </div>
                </template>
                <template #option="provinceOptions">
                  <div>{{ provinceOptions.option.province_name }}</div>
                </template>
              </Dropdown>
            </div>

            <div class="p-field p-col-12 p-lg-4 p-mt-2">
              <label for="amphurOptions">{{ $t("amphur") }}</label>
              <Dropdown
                :disabled="ivs_isDisabledAmphur == 1"
                v-model="ivs_selectedAmphur"
                @change="someHandler('ch-amphur')"
                :options="amphurOptions"
                optionLabel="amphur_name"
                :filter="true"
                :placeholder="$t('placeholderSelectBox')"
                :showClear="true"
                :clearFilterDropdown="dropdownClearFilerValue"
              >
                <template #value="amphurOptions">
                  <div v-if="amphurOptions.value">
                    <div>{{ amphurOptions.value.amphur_name }}</div>
                  </div>
                </template>
                <template #option="amphurOptions">
                  <div>{{ amphurOptions.option.amphur_name }}</div>
                </template>
              </Dropdown>
            </div>

            <div class="p-field p-col-12 p-lg-4 p-mt-2">
              <label for="tambonOptions">{{ $t("tambon") }}</label>
              <Dropdown
                :disabled="ivs_isDisabledTambon == 1"
                v-model="ivs_selectedTambon"
                :options="tambonOptions"
                optionLabel="tambon_name"
                :filter="true"
                :placeholder="$t('placeholderSelectBox')"
                :showClear="true"
                :clearFilterDropdown="dropdownClearFilerValue"
              >
                <template #value="tambonOptions">
                  <div v-if="tambonOptions.value">
                    <div>{{ tambonOptions.value.tambon_name }}</div>
                  </div>
                </template>
                <template #option="tambonOptions">
                  <div>{{ tambonOptions.option.tambon_name }}</div>
                </template>
              </Dropdown>
            </div>
          </div>

          <div class="p-formgrid p-grid p-col">

            <!-- <div class="p-field p-col-12 p-lg-4 p-mt-2">
              <label for="ivs_phone_number">{{ $t("phone_number") }}</label>
              <InputText
                id="ivs_phone_number"
                type="text"
                v-model="ivs_phone_number"
                @input="acceptNumber"
              />
            </div> -->

            <div class="p-field p-col-12 p-lg-4 p-mt-2">
              <label for="ivs_phone_number">{{ $t("phone_number") }}
                <span class="required-input"></span></label>
              <InputText
                id="ivs_phone_number"
                type="text"
                v-model="ivs_phone_number"
                @input="acceptNumberPhone"
                ref="TextBox_11_Member"
                @keyup.left="moveFocus($event, 'TextBox_10_Member','Input')"
                @keyup.right="moveFocus($event, 
                isDisabledBtnShowOrg !== 1 ? 'TextBox_12_Member' : 'TextBox_14_Member',
                isDisabledBtnShowOrg !== 1 ? 'Button' : 'Input')"
                @keyup.up="moveFocus($event, 'TextBox_10_Member','Input')"
                @keyup.down="moveFocus($event, 
                isDisabledBtnShowOrg !== 1 ? 'TextBox_12_Member' : 'TextBox_14_Member',
                isDisabledBtnShowOrg !== 1 ? 'Button' : 'Input')"
              />
            </div>

            <div class="p-field p-col-12 p-lg-3 p-mt-2">
              <label for="victimStatusSelected"
                >{{ $t("iv_victim_status") }}
                <span class="required-input">*</span></label
              >
              <Dropdown
                v-model="ivs_victimStatusSelected"
                :options="victimStatusOptions"
                optionLabel="system_name"
                :class="{
                  'p-invalid':
                    error_ivs_victimStatusSelected && !ivs_victimStatusSelected,
                }"
                :filter="true"
                :placeholder="$t('placeholderSelectBox')"
                :showClear="true"
                :clearFilterDropdown="dropdownClearFilerValue"
              >
                <template #value="victimStatusOptions">
                  <div v-if="victimStatusOptions.value">
                    <div>{{ victimStatusOptions.value.system_name }}</div>
                  </div>
                  <span v-else>
                    {{ victimStatusOptions.placeholder }}
                  </span>
                </template>
                <template #option="victimStatusOptions">
                  <div>{{ victimStatusOptions.option.system_name }}</div>
                </template>
              </Dropdown>
              <small
                class="p-invalid"
                v-if="
                  error_ivs_victimStatusSelected && !ivs_victimStatusSelected
                "
                >{{ $t("ivs_victimStatusSelected_validate") }}</small
              >
            </div>
            <div class="p-field p-col-12 p-lg-3 p-mt-2 p-mt-2">
              <div class="p-field-checkbox p-mt-5">
                <Checkbox
                  id="ivs_headerFamily"
                  name="ivs_headerFamily"
                  value="1"
                  v-model="ivs_check_headerFamily"
                />
                <label for="ivs_headerFamily">{{
                  $t("iv_table_headerFamily")
                }}</label>
              </div>
            </div>
          </div>

          <div class="p-formgrid p-grid p-col">
            <div class="p-field p-col-12 p-lg-1 p-mt-2 ">
              <div class="p-field-checkbox p-mt-5">
                <Checkbox
                  id="ivs_check_officer"
                  name="ivs_check_officer"
                  value="1"
                  v-model="ivs_check_officer"
                />
                <label for="ivs_check_officer">{{
                  $t("iv_submodal_checkedOfficer")
                }}</label>
              </div>
            </div>
            <div class="p-field p-col-7 p-lg-7 p-mt-2">
              <label for="ivs_selectedOrganize">{{
                $t("organize_original")
              }}</label>
              <InputText
                id="ivs_selectedOrganize"
                type="text"
                v-model="ivs_selectedOrganize.name"
                disabled
              />
            </div>
            <div class="p-field p-col-4 p-lg-2" style="padding: 3.5px 0 0 7px;">
              <div>
                <Button
                  :disabled="isDisabledBtnShowOrg == 1"
                  @click="showOrganize = true"
                  icon="pi pi-ellipsis-h"
                  class="p-button-secondary p-mt-5 p-mr-2"
                  ref="TextBox_12_Member"
                  @keyup.left="moveFocus($event, 'TextBox_11_Member' , 'Input')"
                  @keyup.right="moveFocus($event,  'TextBox_13_Member','Button')"
                  @keyup.up="moveFocus($event, 'TextBox_11_Member','Input')"
                  @keyup.down="moveFocus($event, 'TextBox_14_Member','Input')"
                />
                <Button
                  :disabled="isDisabledBtnCancelOrg == 1"
                  @click="ivs_selectedOrganize = {}"
                  icon="pi pi-times"
                  class="p-button-danger p-mt-5"
                  ref="TextBox_13_Member"
                  @keyup.left="moveFocus($event, 'TextBox_12_Member' , 'Button')"
                  @keyup.right="moveFocus($event,  'TextBox_14_Member','Input')"
                  @keyup.up="moveFocus($event, 'TextBox_11_Member','Input')"
                  @keyup.down="moveFocus($event, 'TextBox_14_Member','Input')"
                />
              </div>
            </div>
          </div>

          <div class="p-formgrid p-grid p-col">
            <div class="p-field p-col-12 p-lg-12 p-mt-2">
              <label for="ivs_effectdetail">{{
                $t("iv_submodal_effectdetail")
              }}</label>
              <Textarea
                id="ivs_effectdetail"
                type="text"
                rows="2"
                v-model="ivs_effectdetail"
                ref="TextBox_14_Member"
                @keyup.left="moveFocus($event, 
                isDisabledBtnShowOrg !== 1 ? 'TextBox_13_Member' : 'TextBox_11_Member',
                isDisabledBtnShowOrg !== 1 ? 'Button' : 'Input')"
                @keyup.right="moveFocus($event,  'TextBox_15_Member','InputNumber')"
                @keyup.up="moveFocus($event,  
                isDisabledBtnShowOrg !== 1 ? 'TextBox_13_Member' : 'TextBox_11_Member',
                isDisabledBtnShowOrg !== 1 ? 'Button' : 'Input')"
                @keyup.down="moveFocus($event, 'TextBox_15_Member','InputNumber')"
              />
            </div>
          </div>

          <hr />
          <label>{{ $t("iv_submodal_basichelp_topic") }}</label>
          <div class="p-formgrid p-grid p-col">
            <div class="p-field p-col-12 p-lg-3 p-mt-2">
              <label for="ivs_basichelp_hospital">{{
                $t("iv_submodal_basichelp_hospital")
              }}</label>
              <InputNumber
                id="ivs_basichelp_hospital"
                mode="decimal"
                :min="0"
                :minFractionDigits="2"
                :maxFractionDigits="2"
                v-model="ivs_basichelp_hospital"
                ref="TextBox_15_Member"
                @keyup.left="moveFocus($event,'TextBox_14_Member','Input')"
                @keyup.right="moveFocus($event,  'TextBox_16_Member','InputNumber')"
                @keyup.up="moveFocus($event,'TextBox_14_Member','Input')"
                @keyup.down="moveFocus($event, 'TextBox_19_Member','Button')"
              />
            </div>
            <div class="p-field p-col-12 p-lg-3 p-mt-2">
              <label for="ivs_basichelp_consolation">{{
                $t("iv_submodal_basichelp_consolation")
              }}</label>
              <InputNumber
                id="ivs_basichelp_consolation"
                tmode="decimal"
                :min="0"
                :minFractionDigits="2"
                :maxFractionDigits="2"
                v-model="ivs_basichelp_consolation"
                ref="TextBox_16_Member"
                @keyup.left="moveFocus($event,'TextBox_15_Member','InputNumber')"
                @keyup.right="moveFocus($event,  'TextBox_17_Member','InputNumber')"
                @keyup.up="moveFocus($event,'TextBox_14_Member','Input')"
                @keyup.down="moveFocus($event, 'TextBox_19_Member','Button')"
                
              />
            </div>
            <div class="p-field p-col-12 p-lg-3 p-mt-2">
              <label for="ivs_basichelp_corpsemanage">{{
                $t("iv_submodal_basichelp_corpsemanage")
              }}</label>
              <InputNumber
                id="ivs_basichelp_corpsemanage"
                mode="decimal"
                :min="0"
                :minFractionDigits="2"
                :maxFractionDigits="2"
                v-model="ivs_basichelp_corpsemanage"
                ref="TextBox_17_Member"
                @keyup.left="moveFocus($event,'TextBox_16_Member','InputNumber')"
                @keyup.right="moveFocus($event,  'TextBox_18_Member','InputNumber')"
                @keyup.up="moveFocus($event,'TextBox_14_Member','Input')"
                @keyup.down="moveFocus($event, 'TextBox_19_Member','Button')"
              />
            </div>
            <div class="p-field p-col-12 p-lg-3 p-mt-2">
              <label for="ivs_basichelp_cost">{{
                $t("iv_submodal_basichelp_cost")
              }}</label>
              <InputNumber
                id="ivs_basichelp_cost"
                mode="decimal"
                :min="0"
                :minFractionDigits="2"
                :maxFractionDigits="2"
                v-model="ivs_basichelp_cost"
                ref="TextBox_18_Member"
                @keyup.left="moveFocus($event,'TextBox_17_Member','InputNumber')"
                @keyup.right="moveFocus($event,  'TextBox_19_Member','Button')"
                @keyup.up="moveFocus($event,'TextBox_14_Member','Input')"
                @keyup.down="moveFocus($event, 'TextBox_19_Member','Button')"
              />
            </div>
          </div>

          <hr />
          <div class="p-formgrid p-grid p-col-12">
            <div class="p-field p-col-10">
              <label>{{ $t("iv_submodal_otherhelp_topic") }}</label>
            </div>
            <div class="p-field p-col-6 p-lg-2 p-justify-end">
              <Button
                @click="helpModal = true"
                icon="pi pi-plus"
                :label="$t('addBtn')"
                class="p-button-success"
                ref="TextBox_19_Member"
                @keyup.left="moveFocus($event,'TextBox_18_Member','InputNumber')"
                @keyup.right="moveFocus($event,  'TextBox_20_Member','Button')"
                @keyup.up="moveFocus($event,'TextBox_18_Member','InputNumber')"
                @keyup.down="moveFocus($event, 'TextBox_20_Member','Button')"
              />
            </div>
          </div>
          <div class="p-formgrid p-grid p-col-12">
            <div class="p-field p-col-12">
              <DataTable
                :value="help_table"
                :scrollable="true"
      scrollHeight="500px"
                :paginator="true"
                :rows="5"
                dataKey="id"
                :rowHover="true"
               
                paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                :rowsPerPageOptions="[5, 10, 20, 50]"
                currentPageReportTemplate="แสดงผล {first} ถึง {last} จากทั้งหมด {totalRecords}"
              >
                <template #empty>{{ $t("TableEmpty") }}</template>
                <Column
                  field="name"
                  :header="$t('iv_submodal_otherhelp_name')"
                  :sortable="true"
                  headerStyle="width: 15rem"
                >
                  <template #body="dataTable">
                    {{ dataTable.data.name }}
                  </template>
                </Column>
                <Column
                  field="organize"
                  :header="$t('iv_submodal_otherhelp_organize')"
                  :sortable="true"
                  headerStyle="width: 15rem"
                >
                  <template #body="dataTable">
                    {{ dataTable.data.organize }}
                  </template>
                </Column>
                <Column
                  field="money"
                  :header="$t('iv_submodal_otherhelp_money')"
                  :sortable="true"
                  headerStyle="width: 15rem"
                >
                  <template #body="dataTable">
                    {{ dataTable.data.money }}
                  </template>
                </Column>
                <Column :header="$t('controlTable')" headerStyle="width: 15rem">
                  <template #body="dataTable">
                    <Button
                      @click="
                        helpModal = true;
                        editAt = 'help-table';
                        helpTableDelete = dataTable.data;
                        editHelpData(dataTable.data);
                      "
                      icon="pi pi-pencil"
                      class="p-button-rounded p-button-warning p-mr-3"
                    />
                    <Button
                      @click="
                        // displayConfirmation = true;
                        helpTableDelete = dataTable.data;
                        deleteAt = 'help-table';
                        alertDisplay(helpTableDelete,deleteAt)
                      "
                      icon="pi pi-trash"
                      class="p-button-rounded p-button-danger"
                    />
                  </template>
                </Column>
              </DataTable>
            </div>
          </div>

          <hr />
          <div class="p-formgrid p-grid p-col-12">
            <div class="p-field p-col-10">
              <label>{{ $t("iv_submodal_damage_topic") }}</label>
            </div>
            <div class="p-field p-col-6 p-lg-2 p-justify-end">
              <Button
                @click="damageModal = true"
                icon="pi pi-plus"
                :label="$t('addBtn')"
                class="p-button-success"
                ref="TextBox_20_Member"
                @keyup.left="moveFocus($event,'TextBox_19_Member','Button')"
                @keyup.right="moveFocus($event,  'TextBox_21_Member','Button')"
                @keyup.up="moveFocus($event,'TextBox_19_Member','Button')"
                @keyup.down="moveFocus($event, 'TextBox_21_Member','Button')"
              />
            </div>
          </div>
          <div class="p-formgrid p-grid p-col-12">
            <div class="p-field p-col-12">
              <DataTable
                :value="damage_table"
                :scrollable="true"
                scrollHeight="500px"
                :paginator="true"
                :rows="5"
                dataKey="id"
                :rowHover="true"
          
                paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                :rowsPerPageOptions="[5, 10, 20, 50]"
                currentPageReportTemplate="แสดงผล {first} ถึง {last} จากทั้งหมด {totalRecords}"
              >
                <template #empty>{{ $t("TableEmpty") }}</template>
                <Column
                  field="asset"
                  :header="$t('iv_submodal_damage_asset')"
                  :sortable="true"
                  headerStyle="width: 15rem"
                >
                  <template #body="dataTable">
                    {{ dataTable.data.asset }}
                  </template>
                </Column>
                <Column
                  field="detail"
                  :header="$t('iv_submodal_damage_detail')"
                  :sortable="true"
                  headerStyle="width: 15rem"
                >
                  <template #body="dataTable">
                    {{ dataTable.data.detail }}
                  </template>
                </Column>
                <Column
                  field="level"
                  :header="$t('iv_submodal_damage_level')"
                  :sortable="true"
                  headerStyle="width: 15rem"
                >
                  <template #body="dataTable">
                    {{ dataTable.data.level }}
                  </template>
                </Column>
                <Column
                  field="estimate"
                  :header="$t('iv_submodal_damage_estimate')"
                  :sortable="true"
                  headerStyle="width: 15rem"
                >
                  <template #body="dataTable">
                    {{ dataTable.data.estimate }}
                  </template>
                </Column>
                <Column :header="$t('controlTable')" headerStyle="width: 15rem">
                  <template #body="dataTable">
                    <Button
                      @click="
                        damageModal = true;
                        editAt = 'damage-table';
                        damageTableDelete = dataTable.data;
                        editDamageData(dataTable.data);
                      "
                      icon="pi pi-pencil"
                      class="p-button-rounded p-button-warning p-mr-3"
                    />
                    <Button
                      @click="
                        // displayConfirmation = true;
                        damageTableDelete = dataTable.data;
                        deleteAt = 'damage-table';
                        alertDisplay(damageTableDelete,deleteAt)
                      "
                      icon="pi pi-trash"
                      class="p-button-rounded p-button-danger"
                    />
                  </template>
                </Column>
              </DataTable>
            </div>
          </div>
        </div>
      </div>
      <template #footer>
        <Button
          v-if="selectedMemberData != ''"
          :label="$t('cancelBtn')"
          icon="pi pi-times"
          class="p-button-text"
          @click="clearMemberData()"
          ref="TextBox_21_Member"
          @keyup.left="moveFocus($event,'TextBox_20_Member','Button')"
          @keyup.right="moveFocus($event,  'TextBox_22_Member','Button')"
          @keyup.up="moveFocus($event,'TextBox_20_Member','Button')"
        />
        <Button
          v-else
          :label="$t('clearBtn')"
          icon="pi pi-times"
          class="p-button-text"
          @click="clearMemberData()"
          ref="TextBox_21_Member"
          @keyup.left="moveFocus($event,'TextBox_20_Member','Button')"
          @keyup.right="moveFocus($event,  'TextBox_22_Member','Button')"
          @keyup.up="moveFocus($event,'TextBox_20_Member','Button')"
        />
        <Button
          :label="$t('saveBtn')"
          icon="pi pi-check"
          class="p-button-text"
          @click="saveMemberData()"
          ref="TextBox_22_Member"
          @keyup.left="moveFocus($event,'TextBox_21_Member','Button')"
          @keyup.right="moveFocus($event,  'TextBox_1_Member','Input')"
          @keyup.up="moveFocus($event,'TextBox_20_Member','Button')"
        />
      </template>
    </Dialog>

    <!-- Manage help data -->
    <Dialog
      :modal="true"
      :visible.sync="helpModal"
      :style="{ width: '500px' }"
      :header="headerHelp"
    >
      <div class="confirmation-content" @keyup.enter="saveData_Modal('Help_Model')">
        <label>{{ $t("iv_modal_subtitle") }}</label>
        <div class="p-fluid p-mt-3">
          <div class="p-field p-col">
            <label for="iv_submodal_otherhelp_name"
              >{{ $t("iv_submodal_otherhelp_name") }}
              <span class="required-input">*</span></label
            >
            <InputText
              id="iv_submodal_otherhelp_name"
              type="text"
              v-model="iv_submodal_otherhelp_name"
              :class="{
                'p-invalid':
                  error_iv_submodal_otherhelp_name &&
                  !iv_submodal_otherhelp_name,
              }"
              ref="TextBox_1_Help"
              @keyup.left="moveFocus($event, 'TextBox_5_Help','Button')"
              @keyup.right="moveFocus($event, 'TextBox_2_Help','Input')"
              @keyup.down="moveFocus($event, 'TextBox_2_Help','Input')"
            />
            <!-- TextBox_1_Help -->
            <small
              class="p-invalid"
              v-if="
                error_iv_submodal_otherhelp_name && !iv_submodal_otherhelp_name
              "
              >{{ $t("iv_submodal_otherhelp_name_validate") }}</small
            >
          </div>
          <div class="p-field p-col">
            <label for="iv_submodal_otherhelp_organize">{{
              $t("iv_submodal_otherhelp_organize")
            }}</label>
            <InputText
              id="iv_submodal_otherhelp_organize"
              type="text"
              v-model="iv_submodal_otherhelp_organize"
              ref="TextBox_2_Help"
              @keyup.left="moveFocus($event, 'TextBox_1_Help','Input')"
              @keyup.right="moveFocus($event, 'TextBox_3_Help','InputNumber')"
              @keyup.up="moveFocus($event, 'TextBox_1_Help','Input')"
              @keyup.down="moveFocus($event, 'TextBox_3_Help','InputNumber')"
            />
          </div>
          <div class="p-field p-col">
            <label for="iv_submodal_otherhelp_money">{{
              $t("iv_submodal_otherhelp_money")
            }}</label>
            <InputNumber
              id="iv_submodal_otherhelp_money"
              mode="decimal"
              :min="0"
              :minFractionDigits="2"
              :maxFractionDigits="2"
              v-model="iv_submodal_otherhelp_money"
              ref="TextBox_3_Help"
              @keyup.left="moveFocus($event, 'TextBox_2_Help','Input')"
              @keyup.right="moveFocus($event, 'TextBox_4_Help','Button')"
              @keyup.up="moveFocus($event, 'TextBox_2_Help','Input')"
              @keyup.down="moveFocus($event, 'TextBox_4_Help','Button')"
            />
          </div>
        </div>
      </div>
      <template #footer>
        <Button
          v-if="editAt != ''"
          :label="$t('cancelBtn')"
          icon="pi pi-times"
          class="p-button-text"
          @click="helpModal = false"
          ref="TextBox_4_Help"
          @keyup.left="moveFocus($event, 'TextBox_3_Help','InputNumber')"
          @keyup.right="moveFocus($event, 'TextBox_5_Help','Button')"
          @keyup.up="moveFocus($event, 'TextBox_3_Help','InputNumber')"
        />
        <Button
          v-else
          :label="$t('clearBtn')"
          icon="pi pi-times"
          class="p-button-text"
          @click="clearHelpData()"
          ref="TextBox_4_Help"
          @keyup.left="moveFocus($event, 'TextBox_3_Help','InputNumber')"
          @keyup.right="moveFocus($event, 'TextBox_5_Help','Button')"
          @keyup.up="moveFocus($event, 'TextBox_3_Help','InputNumber')"
        />
        <Button
          :label="$t('saveBtn')"
          icon="pi pi-check"
          class="p-button-text"
          @click="saveHelpData()"
          ref="TextBox_5_Help"
          @keyup.left="moveFocus($event, 'TextBox_4_Help','Button')"
          @keyup.right="moveFocus($event, 'TextBox_1_Help','Input')"
          @keyup.up="moveFocus($event, 'TextBox_3_Help','InputNumber')"
        />
      </template>
    </Dialog>

    <!-- Manage damage data -->
    <Dialog
      :modal="true"
      :visible.sync="damageModal"
      :style="{ width: '500px' }"
      :header="headerDamage"
    >
      <div class="confirmation-content" @keyup.enter="saveData_Modal('Damage_Model')">
        <label>{{ $t("iv_modal_subtitle") }}</label>
        <div class="p-fluid p-mt-3">
          <div class="p-formgrid p-grid p-col-12">
            <div class="p-field p-col">
              <label for="iv_submodal_damage_asset"
                >{{ $t("iv_submodal_damage_asset") }}
                <span class="required-input">*</span></label
              >
              <InputText
                id="iv_submodal_damage_asset"
                type="text"
                v-model="iv_submodal_damage_asset"
                :class="{
                  'p-invalid':
                    error_iv_submodal_damage_asset && !iv_submodal_damage_asset,
                }"
                ref="TextBox_1_Damage"
                @keyup.left="moveFocus($event, 'TextBox_5_Damage','Button')"
                @keyup.right="moveFocus($event, 'TextBox_2_Damage','Input')"
                @keyup.down="moveFocus($event, 'TextBox_2_Damage','Input')"

              />
              <!-- TextBox_1_Damage -->
              <small
                class="p-invalid"
                v-if="
                  error_iv_submodal_damage_asset && !iv_submodal_damage_asset
                "
                >{{ $t("iv_submodal_damage_asset_validate") }}</small
              >
            </div>
          </div>
          <div class="p-formgrid p-grid p-col-12">
            <div class="p-field p-col">
              <label for="iv_submodal_damage_detail">{{
                $t("iv_submodal_damage_detail")
              }}</label>
              <Textarea
                id="iv_submodal_damage_detail"
                type="text"
                rows="2"
                v-model="iv_submodal_damage_detail"
                ref="TextBox_2_Damage"
                @keyup.left="moveFocus($event, 'TextBox_1_Damage','Input')"
                @keyup.right="moveFocus($event, 'TextBox_3_Damage','InputNumber')"
                @keyup.up="moveFocus($event, 'TextBox_1_Damage','Input')"
                @keyup.down="moveFocus($event, 'TextBox_3_Damage','InputNumber')"
              />
            </div>
          </div>
          <div class="p-formgrid p-grid p-col-12">
            <div class="p-field p-col" style="margin-top: -5px">
              <label for="iv_submodal_damage_level"
                >{{ $t("iv_submodal_damage_level") }}
                <span class="required-input">*</span></label
              >
              <Dropdown
                v-model="iv_submodal_damage_level"
                :options="damageLevelOptions"
                optionLabel="name"
                :filter="true"
                :placeholder="$t('placeholderSelectBox')"
                :showClear="true"
                :class="{
                  'p-invalid':
                    error_iv_submodal_damage_level && !iv_submodal_damage_level,
                }"
                :clearFilterDropdown="dropdownClearFilerValue"
              >
                <template #value="damageLevelOptions">
                  <div v-if="damageLevelOptions.value">
                    <div>{{ damageLevelOptions.value.name }}</div>
                  </div>
                </template>
                <template #option="damageLevelOptions">
                  <div>{{ damageLevelOptions.option.name }}</div>
                </template>
              </Dropdown>
              <small
                class="p-invalid"
                v-if="
                  error_iv_submodal_damage_level && !iv_submodal_damage_level
                "
                >{{ $t("iv_submodal_damage_level_validate") }}</small
              >
            </div>
            <div class="p-field p-col">
              <label for="iv_submodal_damage_estimate">{{
                $t("iv_submodal_damage_estimate")
              }}</label>
              <InputNumber
                id="iv_submodal_damage_estimate"
                mode="decimal"
                :min="0"
                :minFractionDigits="2"
                :maxFractionDigits="2"
                v-model="iv_submodal_damage_estimate"
                ref="TextBox_3_Damage"
                @keyup.left="moveFocus($event, 'TextBox_2_Damage','Input')"
                @keyup.right="moveFocus($event, 'TextBox_4_Damage','Button')"
                @keyup.up="moveFocus($event, 'TextBox_2_Damage','Input')"
                @keyup.down="moveFocus($event, 'TextBox_4_Damage','Button')"
              />
            </div>
          </div>
        </div>
      </div>
      <template #footer>
        <Button
          v-if="editAt != ''"
          :label="$t('cancelBtn')"
          icon="pi pi-times"
          class="p-button-text"
          @click="damageModal = false"
          ref="TextBox_4_Damage"
          @keyup.left="moveFocus($event, 'TextBox_3_Damage','InputNumber')"
          @keyup.right="moveFocus($event, 'TextBox_5_Damage','Button')"
          @keyup.up="moveFocus($event, 'TextBox_3_Damage','InputNumber')"
        />
        <Button
          v-else
          :label="$t('clearBtn')"
          icon="pi pi-times"
          class="p-button-text"
          @click="clearDamageData()"
          ref="TextBox_4_Damage"
          @keyup.left="moveFocus($event, 'TextBox_3_Damage','InputNumber')"
          @keyup.right="moveFocus($event, 'TextBox_5_Damage','Button')"
          @keyup.up="moveFocus($event, 'TextBox_3_Damage','InputNumber')"
        />
        <Button
          :label="$t('saveBtn')"
          icon="pi pi-check"
          class="p-button-text"
          @click="saveDamageData()"
          ref="TextBox_5_Damage"
          @keyup.left="moveFocus($event, 'TextBox_4_Damage','Button')"
          @keyup.right="moveFocus($event, 'TextBox_1_Damage','Input')"
          @keyup.up="moveFocus($event, 'TextBox_3_Damage','InputNumber')"
        />
      </template>
    </Dialog>

    <Dialog
      :modal="true"
      :header="$t('ConfirmDelete')"
      :visible.sync="displayConfirmation"
      :style="{ width: '350px' }"
    >
      <div class="confirmation-content p-mt-3">
        <i
          class="pi pi-exclamation-triangle p-mr-3 p-mt2"
          style="font-size: 2rem"
        />
        <span>{{ $t("ConfirmDeleteSub") }}</span>
      </div>
      <template #footer>
        <Button
          :label="$t('cancelBtn')"
          icon="pi pi-times"
          @click="displayConfirmation = false"
          class="p-button-text"
        />
        <Button
          :label="$t('confirmBtn')"
          icon="pi pi-check"
          @click="confirmDelete(temp)"
          class="p-button-text"
          autofocus
        />
      </template>
    </Dialog>

    <!-- Are you sure for close this modal -->
    <Dialog
      :modal="true"
      :header="$t('ConfirmCloseModal')"
      :visible.sync="displayConfirmationCloseModal"
      :style="{ width: '350px' }"
    >
      <div class="confirmation-content p-mt-3">
        <span>{{ $t("ConfirmCloseModalSub") }}</span>
      </div>
      <template #footer>
        <Button
          :label="$t('cancelBtn')"
          icon="pi pi-times"
          @click="displayConfirmationCloseModal = false"
          class="p-button-text"
        />
        <Button
          v-if="memberSubModal == true"
          :label="$t('confirmBtn')"
          icon="pi pi-check"
          @click="closeMemberModal()"
          class="p-button-text"
          autofocus
        />
        <Button
          v-else
          :label="$t('confirmBtn')"
          icon="pi pi-check"
          @click="closeMainModal()"
          class="p-button-text"
          autofocus
        />
        <!-- <Button
          v-else
          :label="$t('confirmBtn')"
          icon="pi pi-check"
          @click="closeMainModal()
          reloadPage()"
          class="p-button-text"
          autofocus
        /> -->
      </template>
    </Dialog>
  </div>
</template>

<script>
import organizeTable from "./OrganizeTable";
import disasterEvent from "./DisasterEvent";
import moment from "moment";

import textFooter from "../../mixins/textFooter_Search_html"

export default {
  components: {
    organizeTable,
    disasterEvent,
    textFooter,
  },
  data() {
    return {
      dropdownClearFilerValue:0,
      checkRole:null,
      checkView_data:null,
      checkAdd_data:null,
      checkEdit_data:null,
      checkDelete_data:null,

      th: this.$thaidate,
      victimInfo_table: [],
      filters: {},
      temp: null,
      displayConfirmation: false,
      showOrganize: false,
      showDisasterEvent: false,
      victim_name: "",
      idnumber: "",
      victimStatusOptions: [],
      victimStatusSelected: null,
      iv_checked_headerFamily: "",
      selectedEvent: {},
      disaster_date: "",

      provinceOptions: [],
      amphurOptions: [],
      tambonOptions: [],
      bloodGroupOptions: [
        { id: "A", name: "A" },
        { id: "B", name: "B" },
        { id: "O", name: "O" },
        { id: "AB", name: "AB" },
      ],
      prefixOptions: [],

      victimInfoModal: false,
      header: this.$i18n.t("iv_modal_title_add"),
      iv_family_no: "",
      iv_disaster_name: {},
      iv_operating_modal_receive: "",
      iv_modal_help_consumer: 0.0,
      iv_modal_help_temporary: 0.0,
      iv_modal_help_occupation: 0.0,
      iv_modal_help_contribution: 0.0,

      memberSubModal: false,
      headerSubModal: this.$i18n.t("iv_submodal_title_add"),
      ivs_member: "",
      ivs_gender: "",
      ivs_check_headerFamily: [],
      ivs_selectedProvince: null,
      ivs_selectedAmphur: null,
      ivs_selectedTambon: null,
      ivs_isDisabledAmphur: 1,
      ivs_isDisabledTambon: 1,
      ivs_bloodgroup: null,
      ivs_check_officer: [],
      ivs_religion: "",
      ivs_nationality: "",
      ivs_lastname: "",
      ivs_firstname: "",
      ivs_prefix_name: null,
      ivs_idnumber: "",
      error_idnumber_format: false,
      ivs_race: "",
      ivs_age: 0,
      isDisabledBtnShowOrg: 1,
      isDisabledBtnCancelOrg: 1,
      ivs_relationship: "",
      ivs_occupation: "",
      ivs_address: "",
      ivs_phone_number: "",
      ivs_victimStatusSelected: null,
      ivs_selectedOrganize: {},
      ivs_effectdetail: "",
      ivs_basichelp_hospital: 0.0,
      ivs_basichelp_consolation: 0.0,
      ivs_basichelp_corpsemanage: 0.0,
      ivs_basichelp_cost: 0.0,

      error_ivs_firstname: false,
      error_ivs_victimStatusSelected: false,

      damage_table: [],
      help_table: [],
      member_table: [],

      helpModal: false,
      headerHelp: this.$i18n.t("iv_submodal_otherhelp_topic"),
      iv_submodal_otherhelp_name: "",
      iv_submodal_otherhelp_organize: "",
      iv_submodal_otherhelp_money: 0.0,
      error_iv_submodal_otherhelp_name: false,

      damageModal: false,
      headerDamage: this.$i18n.t("iv_submodal_damage_topic"),
      iv_submodal_damage_asset: "",
      iv_submodal_damage_detail: "",
      damageLevelOptions: [
        { id: "all", name: this.$i18n.t("all") },
        { id: "some", name: this.$i18n.t("some") },
      ],
      iv_submodal_damage_level: null,
      iv_submodal_damage_estimate: 0.0,
      error_iv_submodal_damage_asset: false,
      error_iv_submodal_damage_level: false,

      selectedData: "",
      selectedMemberData: "",

      deleteAt: "",
      memberTableDelete: {},
      helpTableDelete: {},
      damageTableDelete: {},

      error_member_table: false,
      error_iv_disaster_name: false,

      check_add_family: "",
      date_search: "",

      displayConfirmationCloseModal: false,
      tempFor_displayConfirmationCloseModal: "",

      editAt: "",

      loading:false,

      table_BOXmanege:window.innerWidth  > 700 ? 'p-field p-col' : '',
      table_editBTN:window.innerWidth > 700 ? this.$i18n.t('editBtn'):'',
      table_deleteBTN:window.innerWidth > 700 ? this.$i18n.t('deleteBtn'):'',

      table_headerStyle:this.checkInnerWidth('15rem','Column'),
      table_bodyStyle:this.checkInnerWidth('15rem','Body'),

      date_create_form:"",
      date_update_form:"",

      date_create_form_member:"",
      date_update_form_member:"",

      //  
      text_Footer:false,
      Clone_Data_text_Footer:[],
      Data_text_Footer:[
        {
          DataName:"ชื่อผู้ประสบภัย",
          textShow:"",
        },
        {
          DataName:"หมายเลขบัตรประชาชน",
          textShow:"",
        },
        {
          DataName:"สถานภาพ",
          textShow:"",
        },
        {
          DataName:"หัวหน้าครอบครัว",
          textShow:"",
        },
        {
          DataName:"เหตุการณ์สาธารณภัย",
          textShow:"",
        },
        {
          DataName:"วันที่รับแจ้งเหตุ",
          textShow:"",
        },
      ],

    };
  },
  watch: {
    async victimInfoModal(val) {
      if (val == false) {
        if (
          this.tempFor_displayConfirmationCloseModal == "" &&
          
          this.iv_disaster_name.name != undefined &&
          this.member_table != [] &&
          this.selectedData == "" 
        ) {
          // this.displayConfirmationCloseModal = true;
          this.$fire({
                    title: "ยืนยันการปิดหน้าต่างจัดการข้อมูล",
                    text: "คุณต้องการออกจากการจัดการข้อมูลใช่หรือไม่ ?",
                    
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'ตกลง',
                    cancelButtonText:'ยกเลิก',
                  }).then((result) => {
                    
                    if (result.value) {
                     
                      this.victimInfoModal = false;
                      // this.tempFor_displayConfirmationCloseModal = "";
                      // this.iv_family_no = "";
                      // this.iv_disaster_name = {};
                      // this.iv_operating_modal_receive = "";
                      // this.iv_modal_help_consumer = 0;
                      // this.iv_modal_help_temporary = 0;
                      // this.iv_modal_help_occupation = 0;
                      // this.iv_modal_help_contribution = 0;
                      // this.error_member_table = false;
                      // this.error_iv_disaster_name = false;
                      // this.member_table = [];
                     
                      // this.displayConfirmation = false;
                      
                      // console.log("this.member_table",this.member_table)
                      // console.log("sa cloes")
                      // this.setDefault();
                      this.clearData();
                      // this.reloadPage();
                     
                      
                    }else{
                      this.victimInfoModal = true;
                      
                    }
                  })
        } else {
          
          this.victimStatusOptions = [
            // { system_id: "getall", system_name: "เลือกทั้งหมด" },
            { system_id: "gs-99hurt", system_name: "บาดเจ็บ" },
            { system_id: "gs-99die", system_name: "เสียชีวิต" },
            { system_id: "gs-99lost", system_name: "สูญหาย" },
            { system_id: "gs-99other", system_name: "อื่น ๆ" },
          ];
          
          await this.axios
            .post(`${this.$url_service}/victim/family`, {
              body: { topic: "get-latest-family-id" },
            })
            .then((response) => {(this.check_add_family = response.data.data)
            // console.log("this.check_add_family",this.check_add_family)s
          });
            // this.setDefault();
            this.clearData();
            // this.member_table=[]
            
        }
      } else {
        await this.axios
          .post(`${this.$url_service}/victim/family`, {
            body: { topic: "get-latest-family-id" },
          })
          .then((response) => {
            // console.log("add family => " + response.data.data),
              (this.iv_family_no = response.data.data);
          });
        await this.axios
          .post(`${this.$url_service}/general/country`, {
            body: { topic: "get-province" },
          })
          .then((response) => (this.provinceOptions = response.data.data));
        this.victimStatusOptions = [
          { system_id: "gs-99hurt", system_name: "บาดเจ็บ" },
          { system_id: "gs-99die", system_name: "เสียชีวิต" },
          { system_id: "gs-99lost", system_name: "สูญหาย" },
          { system_id: "gs-99other", system_name: "อื่น ๆ" },
        ];

        if (this.temp === null) {
            this.date_create_form = this.checkDate_showEN(new Date())
            this.date_update_form = this.checkDate_showEN(new Date())
          }
      }
    },

    async memberSubModal(val) {
      if (val == false) {
        if (
          this.tempFor_displayConfirmationCloseModal == "" &&
          this.selectedMemberData == "" &&
          this.ivs_firstname != "" &&
          this.ivs_victimStatusSelected != null
        ) {
          // this.displayConfirmationCloseModal = true;
          this.$fire({
                    title: "ยืนยันการปิดหน้าต่างจัดการข้อมูล",
                    text: "คุณต้องการออกจากการจัดการข้อมูลใช่หรือไม่ ?",
                    
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'ตกลง',
                    cancelButtonText:'ยกเลิก',
                  }).then((result) => {
                    
                    if (result.value) {
                     
                      this.memberSubModal = false;      
                      this.clearMemberData();
                      
                    }else{
                      this.memberSubModal = true;
                      
                    }
                  })
        } else {
          this.clearMemberData();
        }
      } else {

        if (this.selectedMemberData == "") {
          this.date_create_form_member = this.checkDate_showEN(new Date())
          this.date_update_form_member = this.checkDate_showEN(new Date())
        }

        this.FocusRef_delay("TextBox_1_Member",'Input')

        await this.axios
          .post(`${this.$url_service}/victim/personnal`, {
            body: { topic: "get-latest-member-id" },
          })
          .then((response) => {
            this.ivs_member = response.data.data;
            // console.log("this.ivs_member",this.ivs_member)
          });

        await this.axios
          .post(`${this.$url_service}/initial/option`, {
            body: { group: "dg-13" },
          })
          .then((response) => {
            this.prefixOptions = response.data.data;
            // console.log("this.prefixOptions",this.prefixOptions)
          });
      }
    },

    displayConfirmationCloseModal(val) {
      if (val == true) {
        if (this.ivs_firstname != "") {
          this.memberSubModal = true;
        } else {
          this.victimInfoModal = true;
        }
      }
    },

    helpModal(val) {
      if (val == false) {
        this.clearHelpData();
      }else{
        this.FocusRef_delay("TextBox_1_Help",'Input')
      }
    },

    damageModal(val) {
      if (val == false) {
        this.clearDamageData();
      }else{
        this.FocusRef_delay("TextBox_1_Damage",'Input')
      }
    },

    async ivs_selectedProvince(val) {
      if (val != null) {
        this.ivs_isDisabledAmphur = 0;
        await this.axios
          .post(`${this.$url_service}/general/country`, {
            body: { topic: "get-amphur", province_id: val.province_id },
          })
          .then((response) => (this.amphurOptions = response.data.data));
      } else {
        this.ivs_isDisabledAmphur = 1;
        this.ivs_selectedAmphur = null;
      }
    },

    async ivs_selectedAmphur(val) {
      if (val != null) {
        this.ivs_isDisabledTambon = 0;
        await this.axios
          .post(`${this.$url_service}/general/country`, {
            body: { topic: "get-tambon", amphur_id: val.amphur_id },
          })
          .then((response) => (this.tambonOptions = response.data.data));
      } else {
        this.ivs_isDisabledTambon = 1;
        this.ivs_selectedTambon = null;
      }
    },

    ivs_check_officer(val) {
      if (val == "1") {
        this.isDisabledBtnShowOrg = 0;
        this.isDisabledBtnCancelOrg = 0;
      } else {
        this.isDisabledBtnShowOrg = 1;
        this.isDisabledBtnCancelOrg = 1;
        this.ivs_selectedOrganize = {};
      }
    },

    async selectedData(val) {
      if (val != "") {
        await this.axios
          .post(`${this.$url_service}/victim/personnal`, {
            body: {
              topic: "get-table",
              victim_id: this.selectedData.victim_id,
              // userOrg: this.checkPermission() ? null : this.getUserOrganize(),
            },
          })
          .then((response) => {(this.member_table = response.data.data)
            // console.log("this.member_table",this.member_table)
          });
      }
    },

    selectedMemberData(val) {
      if (val != "") {
        // console.log("edit member => " + this.selectedMemberData.member_id);
        if (val.prefix != "null") {
          this.ivs_prefix_name = {
            system_id: val.prefix_id,
            system_name: val.prefix_name,
          };
        } else {
          this.ivs_prefix_name = null;
        }
        if (val.bloodgroup != "null") {
          this.ivs_bloodgroup = { id: val.bloodgroup, name: val.bloodgroup };
        } else {
          this.ivs_bloodgroup = null;
        }
        if (val.location_id != "null") {
          this.ivs_selectedProvince = {
            province_id: val.province_id,
            province_name: val.province_name,
          };
          this.ivs_selectedAmphur = {
            amphur_id: val.amphur_id,
            amphur_name: val.amphur_name,
          };
          this.ivs_selectedTambon = {
            tambon_id: val.tambon_id,
            tambon_name: val.tambon_name,
          };
        } else {
          this.ivs_selectedProvince = null;
        }
      }
    },

    iv_modal_help_consumer(val) {
      if (val == null) {
        this.iv_modal_help_consumer = 0.0;
      }
    },

    iv_modal_help_temporary(val) {
      if (val == null) {
        this.iv_modal_help_temporary = 0.0;
      }
    },

    iv_modal_help_occupation(val) {
      if (val == null) {
        this.iv_modal_help_occupation = 0.0;
      }
    },

    iv_modal_help_contribution(val) {
      if (val == null) {
        this.iv_modal_help_contribution = 0.0;
      }
    },

    ivs_age(val) {
      if (val == null) {
        this.ivs_age = 0;
      }
    },

    ivs_basichelp_hospital(val) {
      if (val == null) {
        this.ivs_basichelp_hospital = 0.0;
      }
    },

    ivs_basichelp_consolation(val) {
      if (val == null) {
        this.ivs_basichelp_consolation = 0.0;
      }
    },

    ivs_basichelp_corpsemanage(val) {
      if (val == null) {
        this.ivs_basichelp_corpsemanage = 0.0;
      }
    },

    ivs_basichelp_cost(val) {
      if (val == null) {
        this.ivs_basichelp_cost = 0.0;
      }
    },

    iv_submodal_otherhelp_money(val) {
      if (val == null) {
        this.iv_submodal_otherhelp_money = 0.0;
      }
    },

    iv_submodal_damage_estimate(val) {
      if (val == null) {
        this.iv_submodal_damage_estimate = 0.0;
      }
    },
  },

  created() {
    window.addEventListener('resize', this.handleResize);
      this.handleResize();

    this.initialData();


    const decodedToken = this.decodeJWT(localStorage.getItem('token'));


           this.checkRole = decodedToken.permission_id;

        this.checkView_data = decodedToken.view_data;
        this.checkAdd_data = decodedToken.add_data;
        this.checkEdit_data = decodedToken.edit_data;
        this.checkDelete_data = decodedToken.delete_data;

    // console.log(`checkRole = ${this.checkRole} `);
    // console.log(`checkView_data = ${this.checkView_data} `);
    // console.log(`checkAdd_data = ${this.checkAdd_data} `);
    // console.log(`checkEdit_data = ${this.checkEdit_data} `);
    // console.log(`checkDelete_data = ${this.checkDelete_data} `);

    this.Clone_Data_text_Footer = this.setCloneData(this.Data_text_Footer)

  },
  mounted() {
    // console.log('run mounted()')
    this.clearData()
    
  },
  destroyed() {
        window.removeEventListener('resize', this.handleResize);
    },
  methods: {
    saveData_Modal(ModalName){
      if (ModalName === "search"){
        if (!this.isFocused("TextBox_3_search") &&
            !this.isFocused("TextBox_4_search") &&
            !this.isFocused("TextBox_5_search") &&
            !this.isFocused("TextBox_6_search")) {
              this.searchVictimInfo()
        }
        
      }else if( ModalName === "Modal_Main"){
        if (this.memberSubModal === false && 
            !this.isFocused("TextBox_1") &&
            !this.isFocused("TextBox_2") &&
            !this.isFocused("TextBox_7") &&
            !this.isFocused("TextBox_8") &&
            !this.isFocused("TextBox_9")) {
            this.saveData()
        }
      }else if( ModalName === "Member_Model"){
        if (this.helpModal === false &&
            this.damageModal === false &&
            !this.isFocused("TextBox_12_Member") &&
            !this.isFocused("TextBox_13_Member") &&
            !this.isFocused("TextBox_19_Member") &&
            !this.isFocused("TextBox_20_Member") &&
            !this.isFocused("TextBox_21_Member") &&
            !this.isFocused("TextBox_22_Member")) {
            this.saveMemberData()
        }
      }else if( ModalName === "Help_Model"){
        if (!this.isFocused("TextBox_4_Member") &&
            !this.isFocused("TextBox_5_Member")) {
            this.saveHelpData()
        }
      }else if( ModalName === "Damage_Model"){
        if (!this.isFocused("TextBox_4_Member") &&
            !this.isFocused("TextBox_5_Member")) {
            this.saveDamageData()
        }
      }
    },
    handleResize() {
            this.window.width = window.innerWidth;
            this.window.height = window.innerHeight;

            this.table_BOXmanege = window.innerWidth > 700 ? 'p-field p-col' : ''
            this.table_editBTN = window.innerWidth > 700 ? this.$i18n.t('editBtn'):''
            this.table_deleteBTN = window.innerWidth > 700 ? this.$i18n.t('deleteBtn'):''
            if (window.innerWidth > 700) {
              this.table_headerStyle = this.checkInnerWidth('15rem','Column')
              this.table_bodyStyle = this.checkInnerWidth('15rem','Body')
            }else{
              this.table_headerStyle = this.checkInnerWidth('105px','Column')
              this.table_bodyStyle = this.checkInnerWidth('105px','Body')
            }
    },
    async initialData() {
      this.filters={}
      this.loading = true;
      // console.log("run initialData()")
      await this.axios
        .post(`${this.$url_service}/victim/family`, {
          body: {
            topic: "get-table",
            // userOrg: this.checkPermission() ? null : this.getUserOrganize(),
          },
        })
        .then((response) => {this.victimInfo_table = response.data.data

          this.formatData(this.victimInfo_table)
          // console.log("this.victimInfo_table",this.victimInfo_table)

        });
      this.victimStatusOptions = [
        // { system_id: "getall", system_name: "เลือกทั้งหมด" },
        { system_id: "gs-99hurt", system_name: "บาดเจ็บ" },
        { system_id: "gs-99die", system_name: "เสียชีวิต" },
        { system_id: "gs-99lost", system_name: "สูญหาย" },
        { system_id: "gs-99other", system_name: "อื่น ๆ" },
      ];
      this.loading = false;
    },
    formatData(data){
      for (let index = 0; index < data.length; index++) {
            data[index]["index"] = index+1
          if (data[index].event_date) {
            const element = data[index].event_date.split("/");
            
            let dateNew = new Date(`${element[1]}/${element[0]}/${element[2]}`)
             
            data[index].event_date = moment(dateNew).locale('th').add(543, 'year').format("LLL")
          }

          if (data[index].date_create_ddmmyy == null ||
              data[index].date_create_ddmmyy == "null" ||
              data[index].date_create_ddmmyy == "" ) {
            data[index].date_create_ddmmyy = "-";
          }else{
            data[index].date_create_ddmmyy = this.changeDateToThai(this.checkDate(data[index].date_create_ddmmyy))
          }

          if (data[index].date_update_ddmmyy == null ||
              data[index].date_update_ddmmyy == "null" ||
              data[index].date_update_ddmmyy == "" ) {
            data[index].date_update_ddmmyy = "-";
          }else{
            data[index].date_update_ddmmyy = this.changeDateToThai(this.checkDate(data[index].date_update_ddmmyy))
          }
            
      }
    },
    closeMainModal() {
      // console.log("Close main modal and don`t save data");
      this.victimInfoModal = false;
      this.displayConfirmationCloseModal = false;
      this.clearData();
      // this.reloadPage();
    },

    closeMemberModal() {
      // console.log("Close member and don`t save data");
      this.memberSubModal = false;
      this.displayConfirmationCloseModal = false;
      this.clearMemberData();
    },
    acceptNumberPhone() {
      var x = this.ivs_phone_number
        .replace(/\D/g, "")
        .match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
      this.ivs_phone_number = !x[2]
        ? x[1]
        : x[1] + "-" + x[2] + (x[3] ? "-" + x[3] : "");
    },
    acceptIDNumber() {
      var x = this.ivs_idnumber
        .replace(/\D/g, "")
        .match(/(\d{0,1})(\d{0,4})(\d{0,5})(\d{0,2})(\d{0,1})/);
      this.ivs_idnumber = !x[2]
        ? x[1]
        : x[1] + "-" + x[2] + "-" + x[3] + "-" + x[4] + "-" + x[5];
    },

    acceptIDNumberSearch() {
      var x = this.idnumber
        .replace(/\D/g, "")
        .match(/(\d{0,1})(\d{0,4})(\d{0,5})(\d{0,2})(\d{0,1})/);
      this.idnumber = !x[2]
        ? x[1]
        : x[1] +
          "-" +
          x[2] +
          (x[3] ? "-" + x[3] : "") +
          (x[4] ? "-" + x[4] : "") +
          (x[5] ? "-" + x[5] : "");
    },

    acceptNumber() {
      var x = this.ivs_phone_number
        .replace(/\D/g, "")
        .match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
      this.ivs_phone_number = !x[2]
        ? x[1]
        : x[1] + "-" + x[2] + (x[3] ? "-" + x[3] : "");
    },

    someHandler(message) {
      if (message == "ch-province") {
        this.ivs_selectedAmphur = null;
      }
      if (message == "ch-amphur") {
        this.ivs_selectedTambon = null;
      }
    },

    selectedOrganize_passValue(variable) {
      this.showOrganize = false;
      this.ivs_selectedOrganize = {
        id: variable.organize_id,
        name: variable.organize_name,
      };
    },

    selectedEvent_passValue(variable) {
      // console.log(variable);
      var dateselect_1, dateselect_2;
      if (variable.event_date != null) {
        const date = new Date(variable.event_date);
        const ye = new Intl.DateTimeFormat("en", { year: "numeric" }).format(
          date
        );
        const mo = new Intl.DateTimeFormat("en", { month: "2-digit" }).format(
          date
        );
        const da = new Intl.DateTimeFormat("en", { day: "2-digit" }).format(
          date
        );
        const h = date.getHours();
        const m = date.getMinutes();
        const s = date.getSeconds();
        dateselect_1 = `${da}/${mo}/${ye}`;
        dateselect_2 = `${da}/${mo}/${ye} ${h}:${m}:${s}`;
      } else {
        dateselect_1 = "";
        dateselect_2 = "";
      }

      if (this.victimInfoModal == false) {
        this.selectedEvent = {
          id: variable.hazard_id,
          name: variable.event_name,
        };
        this.disaster_date = dateselect_1;
        this.date_search = dateselect_1;
        this.showDisasterEvent = false;
      } else {
        this.iv_disaster_name = {
          id: variable.hazard_id,
          name: variable.event_name,
        };
        this.iv_operating_modal_receive = dateselect_2;
        this.showDisasterEvent = false;
      }
    },

    async searchVictimInfo() {
      // this.filters={}

      var searchdate;
      if (this.disaster_date != this.date_search) {
        if (this.disaster_date != null && this.disaster_date != "") {
          const date = new Date(this.disaster_date);
          const ye = new Intl.DateTimeFormat("en", { year: "numeric" }).format(
            date
          );
          const mo = new Intl.DateTimeFormat("en", { month: "2-digit" }).format(
            date
          );
          const da = new Intl.DateTimeFormat("en", { day: "2-digit" }).format(
            date
          );
          searchdate = `${ye}-${mo}-${da}`;
        } else {
          searchdate = "";
        }
      } else {
        if (this.date_search != "") {
          var date = this.date_search.split("/");
          searchdate = `${date[2]}-${date[1]}-${date[0]}`;
        } else {
          searchdate = "";
        }
      }
      this.loading = true;
      await this.axios
        .post(`${this.$url_service}/victim/family`, {
          body: {
            topic: "search-table",
            name: this.victim_name,
            idnumber: this.idnumber,
            status: this.victimStatusSelected,
            event: this.selectedEvent,
            event_date: searchdate,
            header: this.iv_checked_headerFamily,
            // userOrg: this.checkPermission() ? null : this.getUserOrganize(),
          },
        })
        .then((response) => {
          this.victimInfo_table = response.data.data

          this.formatData(this.victimInfo_table)

          this.setSearchText_Footer()

        });
        this.loading = false;
    },
    setSearchText_Footer(){
      this.text_Footer=false;
          this.Data_text_Footer = this.setCloneData(this.Clone_Data_text_Footer)
          if (this.victim_name !== "" ||
              this.idnumber !== "" ||
              this.victimStatusSelected !== null ||
              this.iv_checked_headerFamily.length !== 0 ||
              this.selectedEvent.name !== undefined ||
              this.checkDateNull_String(this.disaster_date) ){
              for (let index = 0; index < this.Data_text_Footer.length; index++) {
                const element = this.Data_text_Footer[index];
                if (element.DataName === "ชื่อผู้ประสบภัย" && this.victim_name !== "") {
                  element.textShow = this.victim_name
                }
                if (element.DataName === "หมายเลขบัตรประชาชน" && this.idnumber !== "") {
                  element.textShow = this.idnumber
                }
                if (element.DataName === "สถานภาพ" && this.victimStatusSelected !== null) {
                  element.textShow = this.victimStatusSelected.system_name
                }
                if (element.DataName === "หัวหน้าครอบครัว" && this.iv_checked_headerFamily.length !== 0) {
                  element.textShow = this.iv_checked_headerFamily[0]
                }
                if (element.DataName === "เหตุการณ์สาธารณภัย" && this.selectedEvent.name !== undefined) {
                  element.textShow = this.selectedEvent.name
                }
                if (element.DataName === "วันที่รับแจ้งเหตุ" && this.disaster_date !== null && this.disaster_date !== "") {
                  element.textShow = this.checkInvalid_Date(this.changeDateToThai(this.checkDate(this.disaster_date)),"string")
                }
                  
              }
              this.text_Footer=true;
          }

    },
    checkDateNull_String(info){
      if (typeof info === "object" && info !== null ) {
        return true
      }else{
        if (info !== null && info !== "" && info.length === 10) {
          return true
        }else{
          return false
        }
      }
      
    },
    async confirmDelete() {
      if (this.deleteAt == "member-table") {
        this.member_table = this.member_table.filter(
          (val) => val !== this.memberTableDelete
        );
        this.displayConfirmation = false;
        // console.log("delete-personnal");
        await this.axios.post(
          `${this.$url_service}/victim/personnal?user=${this.getUsername()}`,
          {
            body: {
              topic: "delete-personnal",
              id: this.memberTableDelete.member_id,
            },
          }
        );
        // this.$toast.add({
        //   severity: "success",
        //   summary: "ลบข้อมูลสำเร็จ",
        //   detail: "ข้อมูลผู้ประสบภัย (บุคคล)",
        //   life: 3000,
        // });
         this.$fire({
              title: "ลบข้อมูลสำเร็จ",
              text: `ข้อมูลผู้ประสบภัย (บุคคล)`,
              type: "success",
              timer: 3000,
              confirmButtonColor: '#28B463',
            });
      } else if (this.deleteAt == "help-table") {
        this.help_table = this.help_table.filter(
          (val) => val !== this.helpTableDelete
        );
        this.displayConfirmation = false;
      } else if (this.deleteAt == "damage-table") {
        this.damage_table = this.damage_table.filter(
          (val) => val !== this.damageTableDelete
        );
        this.displayConfirmation = false;
      } else {
        this.displayConfirmation = false;
        // console.log("delete-personnal-maintable");
        await this.axios
          .post(
            `${this.$url_service}/victim/personnal?user=${this.getUsername()}`,
            {
              body: {
                topic: "delete-personnal-maintable",
                id: this.temp,
              },
            }
          )
          .then(() => 
          // this.initialData()
          this.searchVictimInfo()
          );
        // this.$toast.add({
        //   severity: "success",
        //   summary: "ลบข้อมูลสำเร็จ",
        //   detail: "ข้อมูลผู้ประสบภัย (บุคคล)",
        //   life: 3000,
        // });
         this.$fire({
              title: "ลบข้อมูลสำเร็จ",
              text: "ข้อมูลผู้ประสบภัย (บุคคล)",
              type: "success",
              timer: 3000,
              confirmButtonColor: '#28B463',
            });
      }
    },

    async saveMemberData() {
      // this.member_table=[]
      
      if (!this.ivs_phone_number) {
        this.ivs_phone_number = "-"
      }
      
      if (this.ivs_firstname == "" || this.ivs_victimStatusSelected == null) {
        if (this.ivs_firstname == "") {
          this.error_ivs_firstname = true;
        }
        if (this.ivs_victimStatusSelected == null) {
          this.error_ivs_victimStatusSelected = true;
        }
      } else {
        var check_id;
        if (this.ivs_idnumber != "") {
          if (this.ivs_idnumber.length != 17) {
            check_id = true;
          } else {
            check_id = false;
          }
        } else {
          check_id = false;
        }

        if (check_id == false) {
          var family_id_add;
          if (this.selectedMemberData == "") {
            if (this.selectedData != "") {
              family_id_add = this.selectedData.victim_id;
            } else {
              family_id_add = this.iv_family_no;
            }
            await this.axios
              .post(
                `${
                  this.$url_service
                }/victim/personnal?user=${this.getUsername()}`,
                {
                  body: {
                    topic: "add-personnal",
                    userOrg: this.checkPermission() ? null : this.getUserOrganize(),
                    newid: this.ivs_member,
                    prefix: this.ivs_prefix_name,
                    firstname: this.ivs_firstname,
                    lastname: this.ivs_lastname,
                    gender: this.ivs_gender,
                    idnumber: this.ivs_idnumber,
                    race: this.ivs_race,
                    nationality: this.ivs_nationality,
                    religion: this.ivs_religion,
                    age: this.ivs_age,
                    blood: this.ivs_bloodgroup,
                    relation: this.ivs_relationship,
                    occupation: this.ivs_occupation,
                    address: this.ivs_address,
                    location_id: this.ivs_selectedTambon,
                    phonenumber: this.ivs_phone_number,
                    status: this.ivs_victimStatusSelected.system_id,
                    check_header: this.ivs_check_headerFamily,
                    check_officer: this.ivs_check_officer,
                    organize: this.ivs_selectedOrganize.id,
                    effectdetail: this.ivs_effectdetail,
                    basic_hospital: this.ivs_basichelp_hospital,
                    basic_consolation: this.ivs_basichelp_consolation,
                    basic_funeral: this.ivs_basichelp_corpsemanage,
                    basic_cost: this.ivs_basichelp_cost,
                    help_table: this.help_table,
                    damage_table: this.damage_table,
                    victim_id: family_id_add,
                  },
                }
              )
              .then(() => 
              // this.initialData()
              this.searchVictimInfo()
              );

            this.memberSubModal = false;
            // this.$toast.add({
            //   severity: "success",
            //   summary: "บันทึกข้อมูลสำเร็จ",
            //   detail: "ข้อมูลผู้ประสบภัย (บุคคล)",
            //   life: 3000,
            // });
             this.$fire({
              title: "บันทึกข้อมูลสำเร็จ",
              text: "ข้อมูลผู้ประสบภัย (บุคคล)",
              type: "success",
              timer: 3000,
              confirmButtonColor: '#28B463',
            });
            this.tempFor_displayConfirmationCloseModal = "add";
          } else {
            if (this.selectedData != "") {
              family_id_add = this.selectedData.victim_id;
            } else {
              family_id_add = this.iv_family_no;
            }
            //edit member
            await this.axios
              .post(
                `${
                  this.$url_service
                }/victim/personnal?user=${this.getUsername()}`,
                {
                  body: {
                    topic: "edit-personnal",
                    id: this.selectedMemberData.member_id,
                    prefix: this.ivs_prefix_name,
                    firstname: this.ivs_firstname,
                    lastname: this.ivs_lastname,
                    gender: this.ivs_gender,
                    idnumber: this.ivs_idnumber,
                    race: this.ivs_race,
                    nationality: this.ivs_nationality,
                    religion: this.ivs_religion,
                    age: this.ivs_age,
                    blood: this.ivs_bloodgroup,
                    relation: this.ivs_relationship,
                    occupation: this.ivs_occupation,
                    address: this.ivs_address,
                    location_id: this.ivs_selectedTambon,
                    phonenumber: this.ivs_phone_number,
                    status: this.ivs_victimStatusSelected.system_id,
                    check_header: this.ivs_check_headerFamily,
                    check_officer: this.ivs_check_officer,
                    organize: this.ivs_selectedOrganize.id,
                    effectdetail: this.ivs_effectdetail,
                    basic_hospital: this.ivs_basichelp_hospital,
                    basic_consolation: this.ivs_basichelp_consolation,
                    basic_funeral: this.ivs_basichelp_corpsemanage,
                    basic_cost: this.ivs_basichelp_cost,
                    help_table: this.help_table,
                    damage_table: this.damage_table,
                    victim_id: family_id_add,
                  },
                }
              )
              .then(() => 
              // this.initialData()
              this.searchVictimInfo()
              );

            this.memberSubModal = false;
            // this.$toast.add({
            //   severity: "success",
            //   summary: "แก้ไขข้อมูลสำเร็จ",
            //   detail: "ข้อมูลผู้ประสบภัย (บุคคล)",
            //   life: 3000,
            // });
             this.$fire({
              title: "แก้ไขข้อมูลสำเร็จ",
              text: "ข้อมูลผู้ประสบภัย (บุคคล)",
              type: "success",
              timer: 3000,
              confirmButtonColor: '#28B463',
            });
          }
          this.getMemberTableAfterSave(family_id_add);
        }
      }
    },

    async getMemberTableAfterSave(family_id) {
      await this.axios
        .post(`${this.$url_service}/victim/personnal`, {
          body: {
            topic: "get-table",
            victim_id: family_id,
            // userOrg: this.checkPermission() ? null : this.getUserOrganize(),
          },
        })
        .then((response) => {(this.member_table = response.data.data)
          // console.log("this.member_table222",this.member_table)
          
            
          
        });
    },

    saveHelpData() {
      if (this.iv_submodal_otherhelp_name == "") {
        this.error_iv_submodal_otherhelp_name = true;
      } else {
        if (this.editAt == "help-table") {
          this.help_table = this.help_table.filter(
            (val) => val !== this.helpTableDelete
          );
          this.help_table.push({
            name: this.iv_submodal_otherhelp_name,
            organize: this.iv_submodal_otherhelp_organize,
            money: this.iv_submodal_otherhelp_money,
          });
        } else {
          this.help_table.push({
            name: this.iv_submodal_otherhelp_name,
            organize: this.iv_submodal_otherhelp_organize,
            money: this.iv_submodal_otherhelp_money,
          });
        }
        this.helpModal = false;
      }
    },

    editHelpData(data) {
      this.iv_submodal_otherhelp_name = data.name;
      this.iv_submodal_otherhelp_organize = data.organize;
      this.iv_submodal_otherhelp_money = data.money;
    },

    saveDamageData() {
      if (
        this.iv_submodal_damage_asset == "" ||
        this.iv_submodal_damage_level == null
      ) {
        if (this.iv_submodal_damage_asset == "") {
          this.error_iv_submodal_damage_asset = true;
        }
        if (this.iv_submodal_damage_level == null) {
          this.error_iv_submodal_damage_level = true;
        }
      } else {
        if (this.editAt == "damage-table") {
          this.damage_table = this.damage_table.filter(
            (val) => val !== this.damageTableDelete
          );
          this.damage_table.push({
            asset: this.iv_submodal_damage_asset,
            detail: this.iv_submodal_damage_detail,
            level: this.iv_submodal_damage_level.name,
            estimate: this.iv_submodal_damage_estimate,
          });
        } else {
          this.damage_table.push({
            asset: this.iv_submodal_damage_asset,
            detail: this.iv_submodal_damage_detail,
            level: this.iv_submodal_damage_level.name,
            estimate: this.iv_submodal_damage_estimate,
          });
        }
        this.damageModal = false;
      }
    },

    editDamageData(data) {
      this.iv_submodal_damage_asset = data.asset;
      this.iv_submodal_damage_detail = data.detail;
      if (data.level == this.$i18n.t("all")) {
        this.iv_submodal_damage_level = {
          id: "all",
          name: this.$i18n.t("all"),
        };
      } else {
        this.iv_submodal_damage_level = {
          id: "some",
          name: this.$i18n.t("some"),
        };
      }
      this.iv_submodal_damage_estimate = data.estimate;
    },

    async saveData() {
      if (
        this.member_table.length == 0 ||
        this.iv_disaster_name.name == undefined
      ) {
        if (this.selectedData == "") {
          if (this.member_table.length == 0) {
            this.error_member_table = true;
          }
          if (this.iv_disaster_name.name == undefined) {
            this.error_iv_disaster_name = true;
          }
        } else {
          this.victimInfoModal = false;
        }
      } else {
        if (this.selectedData == "") {
          await this.axios
            .post(
              `${this.$url_service}/victim/family?user=${this.getUsername()}`,
              {
                body: {
                  topic: "add-family",
                  userOrg: this.checkPermission() ? null : this.getUserOrganize(),
                  new_id: this.iv_family_no,
                  hazard_id: this.iv_disaster_name,
                  consumer: this.iv_modal_help_consumer,
                  temporary: this.iv_modal_help_temporary,
                  occupation: this.iv_modal_help_occupation,
                  contribution: this.iv_modal_help_contribution,
                },
              }
            )
            .then(() => 
            // this.initialData()
            this.searchVictimInfo()
            );
          this.tempFor_displayConfirmationCloseModal = "add";
          // this.$toast.add({
          //   severity: "success",
          //   summary: "บันทึกข้อมูลสำเร็จ",
          //   detail: "ข้อมูลผู้ประสบภัย (ครอบครัว)",
          //   life: 3000,
          // });
           this.$fire({
              title: "บันทึกข้อมูลสำเร็จ",
              text: "ข้อมูลผู้ประสบภัย (ครอบครัว)",
              type: "success",
              timer: 3000,
              confirmButtonColor: '#28B463',
            });
          this.victimInfoModal = false;
          //เคลีย
          // this.setDefault();
          // this.clearData()
        } else {
          await this.axios
            .post(
              `${this.$url_service}/victim/family?user=${this.getUsername()}`,
              {
                body: {
                  topic: "edit-family",
                  id: this.selectedData.victim_id,
                  hazard_id: this.iv_disaster_name,
                  consumer: this.iv_modal_help_consumer,
                  temporary: this.iv_modal_help_temporary,
                  occupation: this.iv_modal_help_occupation,
                  contribution: this.iv_modal_help_contribution,
                },
              }
            )
            .then(() =>
            //  this.initialData()
            this.searchVictimInfo()
            );
          // this.$toast.add({
          //   severity: "success",
          //   summary: "แก้ไขข้อมูลสำเร็จ",
          //   detail: "ข้อมูลผู้ประสบภัย (ครอบครัว)",
          //   life: 3000,
          // });
           this.$fire({
              title: "แก้ไขข้อมูลสำเร็จ",
              text: "ข้อมูลผู้ประสบภัย (ครอบครัว)",
              type: "success",
              timer: 3000,
              confirmButtonColor: '#28B463',
            });
          this.victimInfoModal = false;
          //เคลีย
          // this.setDefault();
        }
      }
    },

    async editData(data) {
      this.header = this.$i18n.t("iv_modal_title_edit");

      await this.axios
        .post(`${this.$url_service}/victim/family`, {
          body: {
            topic: "showone-family",
            id: data,
          },
        })
        .then((response) => {
          (this.selectedData = response.data.data),
          // (console.log("this.selectedData",this.selectedData)),
            (this.temp = response.data.data.victim_id),
            (this.iv_disaster_name = {
              id: response.data.data.hazard_id,
              name: response.data.data.event_name,
            }),
            (this.iv_operating_modal_receive = response.data.data.event_date),
            (this.iv_modal_help_consumer = Number(
              response.data.data.victim_consume
            )),
            (this.iv_modal_help_temporary = Number(
              response.data.data.victim_habitat
            )),
            (this.iv_modal_help_occupation = Number(
              response.data.data.victim_cost
            )),
            (this.iv_modal_help_contribution = Number(
              response.data.data.victim_contribution
            ));
            this.date_create_form = response.data.data.date_create_ddmmyy == null ? "-" : response.data.data.date_create_ddmmyy
            this.date_update_form = response.data.data.date_update_ddmmyy == null ? "-" : response.data.data.date_update_ddmmyy
        });

        

      await this.axios
        .post(`${this.$url_service}/victim/personnal`, {
          body: {
            topic: "get-table",
            victim_id: data,
            // userOrg: this.checkPermission() ? null : this.getUserOrganize(),
          },
        })
        .then((response) => (this.member_table = response.data.data));
    },

    async editMemberData(data) {
      this.headerSubModal = this.$i18n.t("iv_submodal_title_edit");
      await this.axios
        .post(`${this.$url_service}/victim/personnal`, {
          body: {
            topic: "showone-personnal",
            id: data,
          },
        })
        .then((response) => {
          (this.selectedMemberData = response.data.data),

            (this.ivs_victimStatusSelected = {
              system_id: response.data.data.status_id,
              system_name: response.data.data.status_name,
            }),
            (this.ivs_firstname = response.data.data.firstname),
            (this.ivs_lastname = response.data.data.lastname),
            (this.ivs_gender = response.data.data.gender),
            (this.ivs_idnumber = response.data.data.idnumber),
            (this.ivs_race = response.data.data.race),
            (this.ivs_nationality = response.data.data.nationality),
            (this.ivs_religion = response.data.data.religion),
            (this.ivs_age = Number(response.data.data.age)),
            (this.ivs_relationship = response.data.data.relation),
            (this.ivs_occupation = response.data.data.occupation),
            (this.ivs_address = response.data.data.location),
            (this.ivs_phone_number = response.data.data.phone_number),
            (this.ivs_check_headerFamily = [response.data.data.header]),
            (this.ivs_check_officer = [response.data.data.officer]),
            (this.ivs_selectedOrganize = {
              id: response.data.data.organize_id,
              name: response.data.data.organize_name,
            }),
            (this.ivs_effectdetail = response.data.data.effect_detail),
            (this.ivs_basichelp_hospital = Number(response.data.data.hospital)),
            (this.ivs_basichelp_consolation = Number(
              response.data.data.consolation
            )),
            (this.ivs_basichelp_corpsemanage = Number(
              response.data.data.funeral
            )),
            (this.ivs_basichelp_cost = Number(response.data.data.daily)),
            (this.help_table = JSON.parse(response.data.data.help_table)),
            (this.damage_table = JSON.parse(response.data.data.asset_table));

            this.date_create_form_member = response.data.data.date_create_ddmmyy == null ? "-" : response.data.data.date_create_ddmmyy
            this.date_update_form_member = response.data.data.date_update_ddmmyy == null ? "-" : response.data.data.date_update_ddmmyy
        });
    },

    async clearData() {
      this.dropdownClearFilerValue +=1;
      // console.log('Use clearData !!!!');
      //Edit data
      // console.log('run clearData()')
      if (this.selectedData != "") {
        this.header = this.$i18n.t("iv_modal_title_add");
        this.temp = null;
        this.displayConfirmation = false;
        this.victimInfoModal = false;
        this.selectedData = "";
  
        this.setDefault();
        
        //Add data
      } else {
        // console.log('Use clearData check-null-person !!!!');
        
        this.header = this.$i18n.t("iv_modal_title_add");
        this.temp = null;
        this.displayConfirmation = false;
        
        this.setDefault();
        this.selectedData = "";
        // ! 
        await this.axios.post(`${this.$url_service}/victim/family`, {
          body: { topic: "check-null-person" },
        });
      }
    },

    clearMemberData() {
      this.dropdownClearFilerValue +=1;
      // console.log('Use clearMemberData !!!!');
      // console.log('this.selectedMemberData !!!! =',this.selectedMemberData);
      //Edit data
      if (this.selectedMemberData != "") {
        this.headerSubModal = this.$i18n.t("iv_submodal_title_add");
        this.temp = null;
        this.displayConfirmation = false;
        this.memberSubModal = false;
        this.selectedMemberData = "";
        this.setDefaultMember();
        //Add data
      } else {
        this.headerSubModal = this.$i18n.t("iv_submodal_title_add");
        this.temp = null;
        this.displayConfirmation = false;
        this.setDefaultMember();
      }
    },

    setDefault() {
      this.tempFor_displayConfirmationCloseModal = "";
      this.iv_family_no = "";
      this.iv_disaster_name = {};
      this.iv_operating_modal_receive = "";
      this.iv_modal_help_consumer = 0;
      this.iv_modal_help_temporary = 0;
      this.iv_modal_help_occupation = 0;
      this.iv_modal_help_contribution = 0;
      this.error_member_table = false;
      this.error_iv_disaster_name = false;
      this.member_table = [];
      this.selectedData = "";

      this.date_create_form = ""
      this.date_update_form = ""
    },

    setDefaultMember() {
      this.tempFor_displayConfirmationCloseModal = "";
      this.ivs_gender = "";
      this.ivs_check_headerFamily = [];
      this.ivs_selectedProvince = null;
      this.ivs_bloodgroup = null;
      this.ivs_check_officer = [];
      this.ivs_religion = "";
      this.ivs_nationality = "";
      this.ivs_lastname = "";
      this.ivs_firstname = "";
      this.ivs_prefix_name = null;
      this.ivs_idnumber = "";
      this.ivs_race = "";
      this.ivs_age = 0;
      this.ivs_relationship = "";
      this.ivs_occupation = "";
      this.ivs_address = "";
      this.ivs_phone_number = "";
      this.ivs_victimStatusSelected = null;
      this.ivs_selectedOrganize = {};
      this.ivs_effectdetail = "";
      this.ivs_basichelp_hospital = 0;
      this.ivs_basichelp_consolation = 0;
      this.ivs_basichelp_corpsemanage = 0;
      this.ivs_basichelp_cost = 0;

      this.error_ivs_firstname = false;
      this.error_ivs_victimStatusSelected = false;

      this.damage_table = [];
      this.help_table = [];

      this.selectedMemberData = "";

      this.date_create_form_member = ""
      this.date_update_form_member = ""
    },

    async clearSearchField() {
      this.dropdownClearFilerValue +=1;
      // console.log('Use clearSearchField');
      this.victim_name = "";
      this.idnumber = "";
      this.victimStatusSelected = null;
      this.iv_checked_headerFamily = [];
      this.selectedEvent = {};
      this.disaster_date = "";
      this.filters={}

      this.Data_text_Footer = this.setCloneData(this.Clone_Data_text_Footer)
      this.text_Footer=false;

      // await this.axios
      //   .post(`${this.$url_service}/victim/family`, {
      //     body: {
      //       topic: "get-table",
      //       // userOrg: this.checkPermission() ? null : this.getUserOrganize(),
      //     },
      //   })
      //   .then((response) => (this.victimInfo_table = response.data.data));
      this.initialData()
    },

    clearHelpData() {
      this.dropdownClearFilerValue +=1;
      this.iv_submodal_otherhelp_name = "";
      this.iv_submodal_otherhelp_organize = "";
      this.iv_submodal_otherhelp_money = 0.0;
      this.error_iv_submodal_otherhelp_name = false;
      this.editAt = "";
    },

    clearDamageData() {
      this.dropdownClearFilerValue +=1;
      this.iv_submodal_damage_asset = "";
      this.iv_submodal_damage_detail = "";
      this.iv_submodal_damage_level = null;
      this.iv_submodal_damage_estimate = 0.0;
      this.error_iv_submodal_damage_asset = false;
      this.error_iv_submodal_damage_level = false;
      this.editAt = "";
    },
    alertDisplay(temp,deleteAt) {
      this.$fire({
                    title: "ยืนยันการลบข้อมูล",
                    text: "คุณต้องการลบข้อมูลนี้ใช่หรือไม่ ?",
                    
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'ตกลง',
                    cancelButtonText:'ยกเลิก',
                  }).then((result) => {
                    // console.log(temp)
                    if (result.value) {
                      // console.log(temp)
                      this.confirmDelete(temp,deleteAt)
                    }
                  })
                  
    },
    
  },
};
</script>

<style scoped>
.table_row{
  text-align: center;
}

@media screen and (min-width: 538px) and (max-width: 1200px)  {
  #Search{
      width: 21rem;
    }
}
@media screen and (min-width: 538px){
      #Create{
      width: 146px;
    }
   
}

@media screen and (max-width: 430px) {
 
  .EV_disasterOptions{
  width: 16.75rem;
  overflow-y:scroll;
  }
  .EV_disasterOptions::-webkit-scrollbar {
    width: 0;
    height: 1px;
    
  }

  .EV_disasterOptions::-webkit-scrollbar-track {
      -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.1); 
      
      
  }

  .EV_disasterOptions::-webkit-scrollbar-thumb {
      
      -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.2); 
      
  }
}
.p-field {
  margin-bottom: 0rem;
}
</style>

<style>
.p-datatable-thead {
  border: 2px solid #d6d6d6;
}

.p-datatable-tbody {
  border: 2px solid #d6d6d6;
}
</style>

<style scoped lang="scss">
:deep(.p-datatable-wrapper table){
  border-left: 1px solid #d6d4d4;
  border-right: 1px solid #d6d4d4;
  border-collapse: separate;
  border-spacing: 0;
}
:deep(.p-datatable-scrollable-header-table) {
    background-color: #d6d4d4;
}
:deep(.p-datatable-wrapper){
    max-height: 550px;
    overflow: auto;
}
.p-multiselect {
  min-width: 15rem;
}

.multiselect-custom {
  .p-multiselect-label:not(.p-placeholder) {
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
  }

  .item {
    display: flex;
    align-items: center;
  }

  .item-value {
    padding-left: 10px;
    padding-right: 10px;
    border-radius: 3px;
    display: inline-flex;
    margin-right: 0.5rem;
    background-color: var(--primary-color);
    color: var(--primary-color-text);
  }
}
</style>
